import React, { useEffect, useRef, useState } from "react";
import "./../../components/Publicpoll/publicpoll.scss";
import { Accordion, Dropdown, Modal, OverlayTrigger, ProgressBar } from "react-bootstrap";
import DateTimePicker from "../common/DateTimePicker";
import {
  ALCHEMY_API_KEY,
  api_url,
  BIG_NUMBER_APPROVAL,
  DISPUTE_INITIAL_TIMER,
  is_public_live,
  NEW_FACTORY_CONTRACT,
  platform_chainId,
  RAIN_ARBI_CONTRACT_ADDRESS,
  SHARE_MARKET,
  USDT_SYMBOL,
  usdr_token,
  usdt_token,
  USDT_TOKEN_SYMBOL,
} from "../../utils/Enviroment";
import { useNavigate } from "react-router-dom";
import useWeb3 from "../../hooks/useWeb3";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../hooks/loader";
import {
  req_liquidity,
  twitter_url,
  whatsapp_url,
  facebook_url,
  telegram_url,
} from "../../utils/Enviroment";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useRecoilState } from "recoil";
import {
  userSmartAccount,
  userSmartAccountClient,
  userSmartAccountUsdtBalance,
  userSmartAccountLegacyUsdtBalance,
  userPublicClient,
  hasUnsavedCreateMarketChanges,
  pendingNavigationPath,
  userSmartAccountRainBalance
} from "../RecoilAtom";
import CreatePoolAbi from "../../utils/CreatePoolAbi.json";
import { encodeFunctionData } from "viem";
import BalanceOfAbi from "../../utils/BalanceOfAbi.json";
import { getPoolAddressFromReceipt, getTxHashAndReceipt, handleToFixedOnDecimals, generatePoolShareMessage, handleGasFeeWithBuffer, sendGasFeeAsUsdt, handleGasFeeWithPreparedCalls, handleCheckSession, formatNumbers, getBackgroundColor, preparePreviewPayload, truncateUrl, convertToMwei, getTokenSymbol, convertToWeiEthers, formatSmartDecimal, formatNumberWithCommas, formatDateTime, isSolvencyGateError, checkSolvencyGateViaPreview } from "../../utils/helpers";
import { signPreparedCalls } from "@account-kit/wallet-client";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import {
  getCreatedPool,
  getGeneratedPreview,
  postCreatePoolFallBack,
  tokenToDollarConvertion,
} from "../../utils/services";
import { Alchemy, Network } from "alchemy-sdk";
import { useGetAllBalances } from "../AllBalances";
import ProgressiveProgressBar from "../ProgressiveProgressBar";
import {
  NONE,
  LIGHT_THEME,
  TIMEOUT,
  USDT_MOCK_VALUE,
  NETWORK_FEES,
  ZERO_ADDRESS,
  MARKET_START_DATE_TYPES,
  TOKEN_USDT,
  TOKEN_USDR,
  MARKET_TOKEN,
  TOKEN_RAIN,
  TOKEN_NAME_TO_CONTRACT_ADDRESS,
  TOKEN_NAME_TO_DECIMALS,
  SOCIAL_PLATFORMS,
  DARK_THEME,
  MAX_BUFFER_PERCENTAGE,
  CREATE_MARKET_TIME_BUFFER,
  RAIN_UNIT,
} from "../../utils/constants";
import Platformfee from "../../hooks/dataFetcher/platformFee";
import { notifyError } from "../Toast";
import { useTheme } from "../../contexts/ThemeProvider";
import { DEFAULT_ERROR_HEADING, GAS_FEES_ERROR } from "../../utils/ConstantMessages";
import SolvencyLimitModal from "../SolvencyLimitModal/SolvencyLimitModal";
import { config } from "../../config/wagmi";
import { getChainId } from '@wagmi/core'
import TooltipCustom from "react-bootstrap/Tooltip";
import { format } from "date-fns";
import SEO from "../SEO";
import { ROUTES, PUBLIC_BASE_URL, detailPath } from "../../constants/Routes";

const CustomDropdown = ({ label, value, options, onSelect }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown show={open} onToggle={() => setOpen(!open)} align="end">
      <Dropdown.Toggle variant="success" id={`dropdown-${label}`}>
        <div className="btninner">
          <p className="btnpara">{label}</p>
          <h6 className="btnhead">{value}</h6>
        </div>
        <svg
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.3s",
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M12.8667 6.71141L8.32157 10.8778C8.27936 10.9165 8.22923 10.9473 8.17405 10.9682C8.11887 10.9892 8.05973 11 8 11C7.94027 11 7.88113 10.9892 7.82595 10.9682C7.77077 10.9473 7.72064 10.9165 7.67843 10.8778L3.1333 6.71141C3.06967 6.65314 3.02632 6.57888 3.00875 6.49801C2.99119 6.41715 3.00019 6.33333 3.03462 6.25715C3.06905 6.18098 3.12736 6.11589 3.20217 6.07011C3.27698 6.02434 3.36492 5.99994 3.45487 6H12.5451C12.6351 5.99994 12.723 6.02434 12.7978 6.07011C12.8726 6.11589 12.931 6.18098 12.9654 6.25715C12.9998 6.33333 13.0088 6.41715 12.9912 6.49801C12.9737 6.57888 12.9303 6.65314 12.8667 6.71141Z"
            fill="#212121"
          />
        </svg>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map((opt) => (
          <Dropdown.Item
            key={opt}
            onClick={() => {
              onSelect(opt);
              setOpen(false);
            }}
          >
            {opt} {opt === value && <Tick />}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

// Tick SVG
const Tick = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    style={{ marginLeft: "8px" }}
  >
    <path
      d="M13.3307 4L5.9974 11.3333L2.66406 8"
      stroke="var(--svg-color1)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Createpool = () => {
  const currentDate = new Date();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [loadingSocialPreview, setLoadingSocialPreview] = useState(null);
  const [createdpool, setCreatedPool] = useState([]);
  const [startProgressBar, setStartProgressBar] = useState(false);
  const [errorWhileCreation, setErrorWhileCreation] = useState(false);
  const [errorMessageWhileCreation, setErrorMessageWhileCreation] = useState("");
  const poolQuestion = createdpool?.question;
  const poolOptions = createdpool?.options;
  const poolAccessCode = createdpool?.accessCode;
  const [selectedType, setSelectedType] = useState("public");
  const poolId = createdpool?._id;
  const getAllBalances = useGetAllBalances();
  const handleClose = () =>
    setShow(async () => {
      setHasUnsavedChanges(false);
      setPendingNavPath(null);
      navigate(detailPath(poolId));
      const newBalance = await getAllBalances();
    });
  const web3 = useWeb3();
  const handleShow = () =>
    setShow(() => {
      setLoader(false);
      setShow(true);
    });
  const [loader, setLoader] = useState(false);
  const [isOpendate, setIsOpendate] = useState(false);
  const [isOpendate1, setIsOpendate1] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [description, setDescription] = useState("");
  const [question, setQuestion] = useState("");
  const [tokenInfo, setTokenInfo] = useState({});
  const [options, setOptions] = useState(["", "", NONE]);
  const [showAll, setShowAll] = useState(false);
  const visibleOptions = showAll ? options : options.slice(0, 3);
  const [tags, setTags] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const displayValue = selectedStartDate
    ? format(selectedStartDate, "dd/MM/yyyy hh:mm aa")
    : "Pick a date and time";

  const [selectedEndDate, setSelectedEndDate] = useState("");
  const displayEndValue = selectedEndDate
    ? format(selectedEndDate, "dd/MM/yyyy hh:mm aa")
    : "Pick a date and time";
  const [inputAmount, setInputAmount] = useState("");
  const [oracleFixedFee, setOracleFixedFee] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const api_key = "2318bd9b1ee9b9a732ca";
  const secret_key =
    "78029869855f6acdef83f4ad97ae6b5a0a1afae8146ee9a086394ae612810731";
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);
  const [isCopiedId, setIsCopiedId] = useState(false);
  const [isCopiedLink, setIsCopiedLink] = useState(false);
  const [isCopiedCode, setIsCopiedCode] = useState(false);
  const [gasFeesSpinner, setGasFeesSpiner] = useState(false);
  const [maxButtonSpinner, setMaxButtonSpinner] = useState(false)
  const [barValues, setBarValues] = useState([]);
  const [lockedBars, setLockedBars] = useState([]);
  const smartAccountUsdrBalance = useRecoilValue(userSmartAccountUsdtBalance);
  const smartAccountLegacyUsdtBalance = useRecoilValue(userSmartAccountLegacyUsdtBalance);
  const smartAccountRainBalance = useRecoilValue(userSmartAccountRainBalance);
  const smartAccount = useRecoilValue(userSmartAccount);
  const smartAccountClient = useRecoilValue(userSmartAccountClient);
  const publicClient = useRecoilValue(userPublicClient);
  const { grantPermissions } = useSessionPermissions();
  const { getAllowanceByAddress } = useCheckAllowance();
  const { search } = useLocation();
  const { PercentReturnCalculation } = Platformfee();
  const isPrivatePool = selectedType === "private" ? true : false;
  const isAccessCode = isPrivatePool ? poolAccessCode : null;
  const settings = {
    apiKey: ALCHEMY_API_KEY,
    network: Network.ARB_MAINNET,
  };
  const alchemy = new Alchemy(settings);
  const [gasFeeInUsdt, setGasFeeInUsdt] = useState(0);
  const [isSolvencyLimitReached, setIsSolvencyLimitReached] = useState(false);
  const [showSolvencyModal, setShowSolvencyModal] = useState(false);
  const [isPublicPoolResolverAi, setIsPublicPoolResolverAi] = useState(true);
  const copiedButtonColor = theme === LIGHT_THEME ? "#212121" : "#DAD9D9";
  const [hasUnsavedChanges, setHasUnsavedChanges] = useRecoilState(hasUnsavedCreateMarketChanges);
  const [pendingNavPath, setPendingNavPath] = useRecoilState(pendingNavigationPath);
  const [selectedStartDateType, setSelectedStartDateType] = useState(MARKET_START_DATE_TYPES.CURRENT);
  const [selectedToken, setSelectedToken] = useState(TOKEN_USDR)
  const [rainPriceToUsdt, setRainPriceToUsdt] = useState(0)
  const [minimumLiquidity, setMinimumLiquidity] = useState(req_liquidity)
  const tokenSymbol = selectedToken === TOKEN_RAIN ? TOKEN_RAIN : selectedToken === TOKEN_USDT ? USDT_TOKEN_SYMBOL : USDT_SYMBOL
  // USDT markets are funded and pay network fees in USDT; USDR and RAIN markets pay fees in USDR
  const isUsdtSelected = selectedToken === TOKEN_USDT
  const isUsdrSelected = selectedToken === TOKEN_USDR
  const stableTokenAddress = isUsdtSelected ? usdt_token : usdr_token
  const stableTokenDecimals = TOKEN_NAME_TO_DECIMALS[isUsdtSelected ? TOKEN_USDT : TOKEN_USDR]
  const stableBalance = isUsdtSelected ? smartAccountLegacyUsdtBalance : smartAccountUsdrBalance
  const chainId = getChainId(config)
  const handleCloseLeaving = () => {
    setPendingNavPath(null);
  };

  const handleLeaveNavigation = () => {
    setHasUnsavedChanges(false);
    if (pendingNavPath === 'back') {
      navigate('/');
    } else if (pendingNavPath) {
      navigate(pendingNavPath);
    }
    setPendingNavPath(null);
  }

  const getOracleFees = async () => {
    const onlyOracleFeesNeeded = true;
    const isRainOracle = selectedToken === TOKEN_RAIN;
    try {
      const oracleFeesResponse = await PercentReturnCalculation(
        NEW_FACTORY_CONTRACT,
        onlyOracleFeesNeeded,
      );
      const oracleFees = isRainOracle ? (+oracleFeesResponse / +rainPriceToUsdt) : oracleFeesResponse
      setOracleFixedFee(oracleFees);
      return oracleFeesResponse;
    } catch (error) {
      console.error("Failed to fetch oracle fee.");
      return false;
    }
  };

  const getRainPrice = async () => {
    try {
      const rainPriceRes = await tokenToDollarConvertion(TOKEN_RAIN);
      setRainPriceToUsdt(rainPriceRes);
    } catch (error) {
      console.log("error fetching RAIN price: ", error);
    }
  };

  useEffect(() => {
    const oracleData = async () => {
      await getOracleFees();
      await getRainPrice();
    };
    if (smartAccount) {
      oracleData();
    }
  }, [smartAccount, selectedToken]);

  useEffect(() => {
    if (selectedToken === TOKEN_RAIN && rainPriceToUsdt > 0) {
      setMinimumLiquidity(req_liquidity / rainPriceToUsdt);
    } else {
      setMinimumLiquidity(req_liquidity);
    }
  }, [selectedToken, rainPriceToUsdt]);

  const handleCheckLiquidityAmount = () => {
    if (!inputAmount || isNaN(+inputAmount) || +inputAmount < minimumLiquidity) {
      setErrorWhileCreation(true)
    }
  }

  useEffect(() => {
    const hasAnyContent =
      question.trim() !== '' ||
      description.trim() !== '' ||
      options.some(opt => opt.trim() !== '' && opt !== NONE) ||
      tags.length > 0 ||
      inputAmount.trim() !== '';

    setHasUnsavedChanges(hasAnyContent);
    const handlePopState = () => {
      if (hasAnyContent) {
        setPendingNavPath('back');
        window.history.pushState(null, '', window.location.href);
      }
    };

    if (hasAnyContent) {
      window.history.pushState(null, '', window.location.href);
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [question, description, options, tags, inputAmount]);

  const minLiquidityDisplay = selectedToken === TOKEN_RAIN
    ? `${minimumLiquidity.toFixed(4)} ${TOKEN_RAIN} (~$${req_liquidity})`
    : `$${req_liquidity}`;

  const handleNextStep = (nextStep, isNextButtonabled) => {
    const normalizedOptions = options.map((option) =>
      option.trim().toLowerCase().replace(/\s+/g, " ")
    );
    const uniqueOptions = new Set(normalizedOptions);
    const updatedDate = new Date(currentDate.getTime() + CREATE_MARKET_TIME_BUFFER);
    const selectedDate = selectedStartDate ? new Date(selectedStartDate) : "";
    const parsedAmount = parseFloat(inputAmount);
    const totalPercentage = barValues.reduce(
      (acc, val) => acc + parseFloat(val || 0),
      0
    );
    if (isNextButtonabled) {
      if (nextStep === 2) {
        setCurrentStep(nextStep);
      }
      if (nextStep === 6 && !isPrivatePool) {
        setCurrentStep(nextStep);
      }
      if (nextStep === 3) {
        if (!question || !description || tags?.length === 0) {
          setErrorWhileCreation(true)
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if (nextStep === 4) {
        if (options?.some((option) => option.trim() === "")) {
          setErrorMessageWhileCreation("All outcome options must be filled out.")
          setErrorWhileCreation(true)
          return false;
        }
        if (uniqueOptions.size !== normalizedOptions.length) {
          setErrorMessageWhileCreation("Duplicate outcomes detected. Please ensure all options are unique.")
          setErrorWhileCreation(true)
          return false;
        }
        setErrorMessageWhileCreation('')
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if ((nextStep === 5) || (nextStep === 6 && isPrivatePool)) {
        if (selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT) {
          setSelectedStartDate(updatedDate);
        }
        if (!selectedStartDate && selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC) {
          notifyError(DEFAULT_ERROR_HEADING, "Please select a market start date.");
          return false;
        }
        if (!selectedEndDate) {
          setErrorMessageWhileCreation("Please select a market end date.")
          setErrorWhileCreation(true)
          if (selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT) {
            setSelectedStartDate("");
          }
          return false;
        }
        if (selectedEndDate <= updatedDate && selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT) {
          notifyError(DEFAULT_ERROR_HEADING, "End date must be at least 5 minutes from now.");
          return false;
        }
        if (selectedDate < currentDate && selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC) {
          notifyError(DEFAULT_ERROR_HEADING, "The start date cannot be in the past.");
          return false;
        }
        if (selectedEndDate <= selectedDate && selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC) {
          notifyError(DEFAULT_ERROR_HEADING, "End date must be later than the start date.");
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if ((nextStep === 7) || (nextStep === 8 && isPrivatePool)) {
        if (!inputAmount || isNaN(parsedAmount) || parsedAmount < minimumLiquidity) {
          setErrorWhileCreation(true)
          return false;
        }
        if (isUsdrSelected && USDT_MOCK_VALUE > +stableBalance) {
          notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
          return false;
        }
        if (isUsdrSelected && gasFeeInUsdt <= 0) {
          notifyError(DEFAULT_ERROR_HEADING, `Error in estimating the ${NETWORK_FEES}. Please try again.`);
          return false;
        }
        if (+totalDeduction > +stableBalance) {
          notifyError(DEFAULT_ERROR_HEADING, `Insufficient ${MARKET_TOKEN[selectedToken]?.label} balance for liquidity and network fees.`);
          return false;
        }
        if (totalPercentage !== 100) {
          notifyError(DEFAULT_ERROR_HEADING, "Total percentage must be exactly 100%.");
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
    }
    if (!isNextButtonabled) {
      const step3Check = !question || !description || tags?.length === 0
      const step4Check = options?.some((option) => option.trim() === "") || uniqueOptions.size !== normalizedOptions.length
      const step5Check = (selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC && !selectedStartDate) || !selectedEndDate || (selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT && selectedEndDate <= updatedDate) || (selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC && selectedDate < currentDate) || (selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC && selectedEndDate <= selectedDate);
      const step6Check = !inputAmount || isNaN(parsedAmount) || parsedAmount < minimumLiquidity || (isUsdrSelected && gasFeeInUsdt <= 0) || (isUsdrSelected && USDT_MOCK_VALUE > +stableBalance) || (+totalDeduction > +stableBalance) || totalPercentage !== 100;

      if (nextStep === 2 || nextStep === 1) {
        setCurrentStep(nextStep);
      }
      if (nextStep === 3) {
        if (step3Check) {
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if (nextStep === 4) {
        if (step3Check || step4Check) {
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if ((nextStep === 5) || (nextStep === 6 && isPrivatePool) || (nextStep === 6 && !isPrivatePool)) {
        if (step3Check || step4Check || step5Check) {
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
      if ((nextStep === 7) || (nextStep === 8 && isPrivatePool)) {

        if (step3Check || step4Check || step5Check || step6Check) {
          return false;
        }
        setErrorWhileCreation(false)
        setCurrentStep(nextStep);
      }
    }

  };

  const handleInputChange = async (value, isMaxButton = false) => {
    if (isMaxButton) setMaxButtonSpinner(true);

    const sanitizedValue = Number(value) || "";
    if (
      (selectedToken !== TOKEN_RAIN && sanitizedValue > stableBalance) ||
      (selectedToken === TOKEN_RAIN && sanitizedValue > smartAccountRainBalance)
    ) {
      if (isMaxButton) setMaxButtonSpinner(false);
      return;
    }
    setInputAmount(sanitizedValue);
    await calculateGasFromPrepareCalls(sanitizedValue);

    if (isMaxButton) setMaxButtonSpinner(false);
  };


  const addOption = () => {
    const otherIndex = options.findIndex((opt) => opt === NONE);
    if (otherIndex !== -1) {
      const newOptions = [...options];
      newOptions.splice(otherIndex, 0, "");
      setOptions(newOptions);
      setErrorMessageWhileCreation('')
      setErrorWhileCreation(false)
    } else {
      setOptions([...options, ""]);
      setErrorMessageWhileCreation('')
      setErrorWhileCreation(false)
    }
  };

  const updateOption = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
    setErrorMessageWhileCreation('')
    setErrorWhileCreation(false)
  };

  const deleteOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
    setErrorMessageWhileCreation('')
    setErrorWhileCreation(false)
  };

  const handlePreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const tokens = [
    // { id: 1, name: "ETH", imgSrc: "/assets/poll/eth.svg" },
    { id: 2, name: "USDT", imgSrc: "/assets/poll/usdr.svg" },
    // { id: 3, name: "BNB", imgSrc: "/assets/poll/bnb.svg" },
    // { id: 4, name: "SHIB", imgSrc: "/assets/poll/shib.svg" },
    // { id: 5, name: "DAI", imgSrc: "/assets/poll/dai.svg" },
  ];

  const availableTags = [
    t("Crypto"),
    t("Politics"),
    t("Finance"),
    t("Sports"),
    t("Technology"),
    t("Entertainment"),
    t("Science"),
    t("Business"),
    t("Weather"),
    t("Culture"),
    t("Gaming"),
    t("Legal"),
    t("Military"),
    t("Space"),
    t("Health"),
    t("Education"),
    t("Art"),
    t("Other"),
  ];

  const addTag = (tag) => {
    if (tags.length < 18 && !tags.includes(tag)) {
      setTags([...tags, tag]);
    }
  };

  const deleteTag = (tagToDelete) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const IpfsUpload = async (metadata) => {
    try {
      const formData = new FormData();
      if (metadata?.file) {
        formData.append("file", metadata?.file);
      }
      formData?.append(
        "file",
        new Blob([JSON.stringify(metadata)], { type: "application/json" })
      );
      const res = await fetch(
        "https://api.pinata.cloud/pinning/pinFileToIPFS",
        {
          method: "POST",
          headers: {
            pinata_api_key: `${api_key}`,
            pinata_secret_api_key: `${secret_key}`,
          },
          body: formData,
        }
      );

      const resData = await res.json();
      if (resData?.IpfsHash) {
        return resData?.IpfsHash;
      } else {
        notifyError(DEFAULT_ERROR_HEADING, t("Failed to upload to IPFS."));
        return null;
      }
    } catch (error) {
      console.error("Error uploading images and metadata:", error);
      notifyError(DEFAULT_ERROR_HEADING, t("Failed to upload images and metadata. Please try again."));
      return null;
    }
  };

  const getEstimatedTxGasFee = async (callArgs, isAllowanceNeeded) => {
    let gasFee;
    setIsSolvencyLimitReached(false);
    if (isUsdrSelected && USDT_MOCK_VALUE > +stableBalance) {
      notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
      setGasFeesSpiner(false);
      setGasFeeInUsdt(0);
      return;
    }
    try {
      if (isAllowanceNeeded) {
        gasFee = await handleGasFeeWithPreparedCalls(
          smartAccountClient,
          smartAccount,
          callArgs
        );
      } else {
        gasFee = await handleGasFeeWithBuffer(
          smartAccount,
          callArgs,
          alchemy
        );
      }
      return gasFee;
    } catch (error) {
      console.error("Create market fee estimation failed:", error);
      let isSolvency = isSolvencyGateError(error);
      if (!isSolvency && publicClient) {
        try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
        catch { }
      }
      setIsSolvencyLimitReached(isSolvency);
      setGasFeeInUsdt(0);
      return 0;
    }
  };

  const calculateGasFromPrepareCalls = async (value) => {
    let inputAmountWei;
    if (+value === 0 || value === "") {
      setGasFeeInUsdt(0);
      return;
    }
    if ((new Date(selectedStartDate) < currentDate && selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC) || new Date(selectedEndDate) < currentDate) {
      notifyError(DEFAULT_ERROR_HEADING, "Market start or end date cannot be in the past. Please update it to continue");
      setGasFeeInUsdt(0);
      return;
    }
    if (selectedToken !== TOKEN_RAIN) {
      const AmountMinusMock = value - (USDT_MOCK_VALUE * MAX_BUFFER_PERCENTAGE);
      inputAmountWei = value
        ? convertToMwei(AmountMinusMock, TOKEN_NAME_TO_DECIMALS[selectedToken])
        : "0";
    } else {
      inputAmountWei = value
        ? convertToMwei(value, RAIN_UNIT)
        : "0";
    }
    try {
      setGasFeesSpiner(true);
      const ispublic = !isPrivatePool;
      let startTime;
      if (selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT) {
        const startNowDate = new Date(new Date().getTime() + CREATE_MARKET_TIME_BUFFER);
        startTime = Math.floor(startNowDate.getTime() / 1000);
      } else {
        startTime = Math.floor(selectedStartDate?.getTime() / 1000)
      }
      const endTime = selectedEndDate
        ? Math.floor(selectedEndDate?.getTime() / 1000)
        : 0;
      const options11 = Array.isArray(options) ? options.length : 0;
      const number = 0;
      const isResolverAi = false;
      const inputAmountWeinum = +(inputAmountWei || "0");
      const transformedBarValues = [
        ...barValues.map((value) => Math.floor(value * 100)),
      ];
      const totalRounded = transformedBarValues.reduce(
        (sum, val) => sum + val,
        0
      );
      const difference = 10000 - totalRounded;

      if (difference !== 0) {
        transformedBarValues[transformedBarValues.length - 1] += difference;
      }
      const ipfsUrl = "https://ipfs.io/ipfs/QmVweBcq63YQsA41KCYs8xSxXdeKeJUtkgsohPBMvWhkAt/";

      const contractParams = [
        ispublic,
        isResolverAi,
        smartAccount,
        ZERO_ADDRESS,
        startTime,
        endTime,
        options11,
        number,
        ipfsUrl,
        inputAmountWeinum,
        transformedBarValues,
        smartAccount,
        TOKEN_NAME_TO_CONTRACT_ADDRESS[selectedToken]
      ];
      const bigNumberApproval = BIG_NUMBER_APPROVAL;
      const usdtAllowance = await getAllowanceByAddress(stableTokenAddress, NEW_FACTORY_CONTRACT)
      const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, NEW_FACTORY_CONTRACT)
      const isUsdtApprovalNeeded = usdtAllowance < contractParams[9];
      const isRainApprovalNeeded = rainAllowance < contractParams[9];
      const isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;
      const callArgs = [];
      if (isUsdtApprovalNeeded) {
        callArgs.push({
          to: stableTokenAddress,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [NEW_FACTORY_CONTRACT, bigNumberApproval],
          }),
        });
      }
      if (isRainApprovalNeeded) {
        callArgs.push({
          to: RAIN_ARBI_CONTRACT_ADDRESS,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [NEW_FACTORY_CONTRACT, bigNumberApproval],
          }),
        });
      }

      callArgs.push({
        to: NEW_FACTORY_CONTRACT,
        data: encodeFunctionData({
          abi: CreatePoolAbi,
          functionName: "createPool",
          args: [contractParams],
        }),
      });
      if (isUsdrSelected) {
        callArgs.push({
          to: usdr_token,
          data: sendGasFeeAsUsdt(USDT_MOCK_VALUE),
        });
      }
      const gasFee = await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
      if ((selectedToken !== TOKEN_RAIN && value >= stableBalance)) {
        setInputAmount(formatSmartDecimal((value) - (+gasFee * MAX_BUFFER_PERCENTAGE)))
      }
      setGasFeeInUsdt(gasFee);
      setGasFeesSpiner(false);
    } catch (error) {
      notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
      setGasFeeInUsdt(0);
      setGasFeesSpiner(false);
    }
  };

  const handleCreatePool = async (contractParams) => {
    try {

      const { userPermissions: permissions, userSessionKey: sessionKey } =
        await grantPermissions();
      setMessage(t(`Creating ${isPrivatePool ? "Private" : "Public"} Market`));
      // const gasValueInUsdt = await calculateGasFromPrepareCalls(totalLiquidity);
      // if (
      //   Number(stableBalance) <
      //   Number(gasValueInUsdt) + Number(inputAmount)
      // ) {
      //   notifyError(DEFAULT_ERROR_HEADING,`Insufficient funds for ${NETWORK_FEES}!`);
      //   setStartProgressBar(false);
      //   handleClose7();
      //   return;
      // }
      const bigNumberApproval = BIG_NUMBER_APPROVAL;
      const usdtAllowance = await getAllowanceByAddress(stableTokenAddress, NEW_FACTORY_CONTRACT)
      const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, NEW_FACTORY_CONTRACT)
      const isUsdtApprovalNeeded = +usdtAllowance < +contractParams[9];
      const isRainApprovalNeeded = +rainAllowance < +contractParams[9];
      const callArgs = [];
      if (isUsdtApprovalNeeded) {
        callArgs.push({
          to: stableTokenAddress,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [NEW_FACTORY_CONTRACT, bigNumberApproval],
          }),
        });
      }
      if (isRainApprovalNeeded) {
        callArgs.push({
          to: RAIN_ARBI_CONTRACT_ADDRESS,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "approve",
            args: [NEW_FACTORY_CONTRACT, bigNumberApproval],
          }),
        });
      }
      callArgs.push({
        to: NEW_FACTORY_CONTRACT,
        data: encodeFunctionData({
          abi: CreatePoolAbi,
          functionName: "createPool",
          args: [contractParams],
        }),
      });
      if (isUsdrSelected) {
        callArgs.push({
          to: usdr_token,
          data: sendGasFeeAsUsdt(gasFeeInUsdt),
        });
      }
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: { permissions },
      });
      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const sendResult = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: { permissions },
      });
      const { preparedCallIds } = sendResult;
      const { txHash, receipt } = await getTxHashAndReceipt({
        preparedCallId: preparedCallIds[0],
        smartAccountClient,
        publicClient,
      });
      const poolAddress = await getPoolAddressFromReceipt(
        receipt,
        CreatePoolAbi
      );
      return { poolAddress, txHash };
    } catch (error) {
      console.error("Error in Market creation:", error);
      setStartProgressBar(false);
      setIsButtonDisabled(false);
      handleClose7();
      throw error;
    }
  };

  const getCreatePrivatePool = async () => {
    const selectedDate = selectedStartDate ? new Date(selectedStartDate) : "";
    const currentDate = new Date();
    if (selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC && selectedDate < currentDate) {
      notifyError(DEFAULT_ERROR_HEADING, t("The start date cannot be in the past."));
      return false;
    }
    if (chainId !== platform_chainId) {
      notifyError(DEFAULT_ERROR_HEADING, t("Please connect to the Arbitrum network"));
      return false;
    }
    setIsButtonDisabled(true);
    setStartProgressBar(true);
    handleShow7();
    let startTime;
    if (selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT) {
      const startNowDate = new Date(new Date().getTime() + CREATE_MARKET_TIME_BUFFER);
      startTime = Math.floor(startNowDate.getTime() / 1000);
    } else {
      startTime = Math.floor(selectedStartDate?.getTime() / 1000)
    }
    const endTime = selectedEndDate
      ? Math.floor(selectedEndDate?.getTime() / 1000)
      : 0;
    const formattedStartDate = selectedStartDate ? selectedStartDate.toISOString() : "";
    const formattedEndDate = selectedEndDate ? selectedEndDate.toISOString() : "";

    try {
      const accessToken = localStorage.getItem("accessToken");
      const tokenCheckRes = await fetch(
        `${api_url}/users/check-token-expiration?token=${accessToken}`,
        {
          method: "GET",
        }
      );
      const tokenCheckData = await tokenCheckRes.json();
      if (tokenCheckData.isExpired) {
        notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again."));
        handleClose7();
        return;
      }

      const ispublic = !isPrivatePool;
      const options11 = Array.isArray(options) ? options.length : 0;
      const poolDuration = DISPUTE_INITIAL_TIMER;
      const transformedBarValues = [
        ...barValues.map((value) => Math.floor(value * 100)),
      ];
      const totalRounded = transformedBarValues.reduce(
        (sum, val) => sum + val,
        0
      );
      const difference = 10000 - totalRounded;
      if (difference !== 0) {
        transformedBarValues[transformedBarValues.length - 1] += difference;
      }
      const metadata = {
        question: question,
        options: Array.isArray(options) ? options : [],
        tags: tags,
        isPrivate: isPrivatePool,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        poolDescription: description,
        isAiResolver: isPublicPoolResolverAi,
        contractData: {
          pool_owner: smartAccount,
          start_time: startTime,
          end_time: endTime,
          no_of_options: options11,
        },
      };
      const ipfsUrl = await IpfsUpload(metadata);
      const inputAmountWei = totalLiquidity
        ? convertToWeiEthers(totalLiquidity, TOKEN_NAME_TO_DECIMALS[selectedToken])
        : "0";
      if (!ipfsUrl) return;
      const isSessionExists = await handleCheckSession();
      setMessage(
        isSessionExists
          ? "Confirm the transaction in your wallet"
          : t(`Creating ${isPrivatePool ? "Private" : "Public"} Market`)
      );
      const contractParams = [
        ispublic,
        isPublicPoolResolverAi,
        smartAccount,
        ZERO_ADDRESS,
        startTime,
        endTime,
        options11,
        poolDuration,
        ipfsUrl,
        inputAmountWei,
        transformedBarValues,
        smartAccount,
        TOKEN_NAME_TO_CONTRACT_ADDRESS[selectedToken]
      ];
      const result = await handleCreatePool(contractParams);
      if (!result) return;
      const { poolAddress, txHash } = result;
      if (poolAddress && txHash) {
        await getPoolInfo(poolAddress);
      }
    } catch (error) {
      let isSolvency = isSolvencyGateError(error);
      if (!isSolvency && publicClient) {
        try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
        catch {  }
      }
      if (isSolvency) {
        setShowSolvencyModal(true);
        setStartProgressBar(false);
        handleClose7();
        setMessage("");
        return;
      }
      try {
        const payload = {
          question: question,
          isPrivate: isPrivatePool,
          ...(description?.trim() && { poolDescription: description }),
          options: Array.isArray(options)
            ? options.map((opt) => ({ optionName: opt }))
            : [],
          startDate: new Date(formattedStartDate).toISOString(),
          endDate: new Date(formattedEndDate).toISOString(),
          tags: Array.isArray(tags) ? tags : [tags],
        };
        await createPoolFallBack(payload);
      } catch (error) {
        notifyError(DEFAULT_ERROR_HEADING, t("Market Creation Failed. Please try again"));
        console.error("Error in createMarket:", error);
        setStartProgressBar(false);
        handleClose7();
        setMessage("");
      }
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const getPoolInfo = async (poolAddress) => {
    let retries = 0;
    const maxRetries = 15;
    const retryDelay = 800;

    const poll = async () => {
      try {
        const createdPoolRes = await getCreatedPool(poolAddress);
        setTokenInfo(createdPoolRes);
        if (createdPoolRes) {
          setStartProgressBar(false);
          setTimeout(() => {
            setCreatedPool(createdPoolRes);
            handleClose7();
            handleShow();
            setMessage("");
            clearInterval(interval);
          }, TIMEOUT);
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          retries++;
          if (retries >= maxRetries) {
            clearInterval(interval);
            console.error("Failed to retrieve Market data after creation.");
            setMessage("");
          }
        } else {
          console.error("Unexpected error:", error);
          clearInterval(interval);
          setMessage("");
        }
      }
    };

    const interval = setInterval(poll, retryDelay);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const createPoolFallBack = async (payload) => {
    let attempts = 0;
    const maxAttempts = 20;

    while (attempts < maxAttempts) {
      try {
        const createdPoolRes = await postCreatePoolFallBack(payload);
        if (createdPoolRes) {
          await getPoolInfo(createdPoolRes?.data?.data?.contractAddress);
          return;
        } else {
          throw new Error("No poolAddress found in response");
        }
      } catch (error) {
        attempts++;
        if (attempts >= maxAttempts) {
          notifyError(DEFAULT_ERROR_HEADING, t("Market Creation Failed. Please try again"));
          console.error("Error in createMarket:", error);
          setStartProgressBar(false);
          handleClose7();
          setMessage("");
          break;
        } else {
          console.log(` Retrying... attempt ${attempts + 1}`);
          await delay(5000);
        }
      }
    }
  };

  const handleCopyClickId = () => {
    const textToCopy = poolId || "";
    copyToClipboard(textToCopy);
    setIsCopiedId(true);
    setTimeout(() => setIsCopiedId(false), 1000);
  };

  const handleCopyClickLink = async () => {
    const textToCopy = `${SHARE_MARKET}/?id=${poolId}&theme=${theme}`;
    copyToClipboard(textToCopy);
    setIsCopiedLink(true);
    await getGeneratedPreviewData();
    setTimeout(() => setIsCopiedLink(false), 1000);
  };

  const handleCopyClickCode = () => {
    const textToCopy = createdpool?.accessCode || "";
    copyToClipboard(textToCopy);
    setIsCopiedCode(true);
    setTimeout(() => setIsCopiedCode(false), 1000);
  };

  const copyToClipboard = (text) => {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const getMinTime = (date) => {
    if (isToday(date)) {
      return new Date();
    }
    return new Date(date.setHours(0, 0, 0, 0));
  };

  useEffect(() => {
    const numOptions = options.length;
    const otherIndex = options.findIndex((opt) => opt === NONE);
    let newBarValues = [];
    let newLockedBars = [];
    const normalOptions = numOptions - 1;
    const equalShare = normalOptions > 0 ? Math.floor(99 / normalOptions) : 0;
    const remainder = 99 - equalShare * normalOptions;
    options.forEach((option, index) => {
      if (option === NONE) {
        newBarValues[index] = 1;
        newLockedBars[index] = true;
      } else {
        const isLastNormalOption =
          index === (otherIndex > 0 ? otherIndex - 1 : numOptions - 2);
        newBarValues[index] = equalShare + (isLastNormalOption ? remainder : 0);
        newLockedBars[index] = false;
      }
    });
    setBarValues(newBarValues);
    setLockedBars(newLockedBars);
  }, [options]);

  const distributeRemaining = (newValue, changedIndex) => {
    let updatedValues = [...barValues];
    updatedValues[changedIndex] = newValue;
    const lockedTotal = barValues.reduce(
      (sum, value, index) => (lockedBars[index] ? sum + value : sum),
      0
    );
    let remainingPercentage = 100 - lockedTotal - newValue;
    const unlockedIndices = updatedValues
      .map((_, index) => index)
      .filter((index) => index !== changedIndex && !lockedBars[index]);
    if (unlockedIndices.length > 0) {
      let minRemaining = unlockedIndices.length;
      let distributable = Math.max(0, remainingPercentage - minRemaining);
      let equalShare = Math.floor(distributable / unlockedIndices.length);
      let lastShare =
        remainingPercentage - equalShare * (unlockedIndices.length - 1);
      unlockedIndices.forEach((index, i) => {
        updatedValues[index] =
          i === unlockedIndices.length - 1
            ? Math.max(1, lastShare)
            : Math.max(1, equalShare);
      });
      let total = updatedValues.reduce((sum, val) => sum + val, 0);
      let diff = 100 - total;
      if (diff !== 0) {
        let lastIndex =
          unlockedIndices.length > 0
            ? unlockedIndices[unlockedIndices.length - 1]
            : changedIndex;
        updatedValues[lastIndex] += diff;
      }
    }
    return updatedValues;
  };

  const handleChange = (event, changedIndex) => {
    if (lockedBars[changedIndex]) return;
    let newValue = parseFloat(event.target.value);
    const lockedTotal = barValues.reduce(
      (sum, value, index) => (lockedBars[index] ? sum + value : sum),
      0
    );
    const maxAllowed =
      100 - lockedTotal - (lockedBars.filter((x) => !x).length - 1);
    newValue = Math.min(maxAllowed, Math.max(1, newValue));
    const updatedValues = distributeRemaining(newValue, changedIndex);
    setBarValues(updatedValues);
  };

  const handleInputChange3 = (event, changedIndex) => {
    if (lockedBars[changedIndex]) return;
    let inputValue = event.target.value;
    if (inputValue === "") {
      let tempValues = [...barValues];
      tempValues[changedIndex] = "";
      setBarValues(tempValues);
      return;
    }
    let newValue = parseFloat(inputValue);
    if (isNaN(newValue) || newValue < 1) newValue = 1;
    const lockedTotal = barValues.reduce(
      (sum, value, index) => (lockedBars[index] ? sum + value : sum),
      0
    );
    const maxAllowed =
      100 - lockedTotal - (lockedBars.filter((x) => !x).length - 1);
    newValue = Math.min(maxAllowed, newValue);
    const updatedValues = distributeRemaining(newValue, changedIndex);
    setBarValues(updatedValues);
  };

  const toggleLock = (index) => {
    const newLockedBars = [...lockedBars];
    newLockedBars[index] = !newLockedBars[index];
    setLockedBars(newLockedBars);
  };

  const copyPoolLink = async () => {
    const textToCopy = `${SHARE_MARKET}/?id=${poolId}&theme=${theme}`;
    copyToClipboard(textToCopy);
    await getGeneratedPreviewData();
  };

  const calculateValues = (amount) => {
    const getAmount = Number(amount) || 0;
    const totalLiquidity = Math.max(getAmount - oracleFixedFee, 0);
    if (selectedToken === TOKEN_RAIN) {
      const rainDeduction = getAmount;
      const usdtDeduction = gasFeeInUsdt;
      return {
        totalLiquidity,
        rainDeduction,
        usdtDeduction,
      };
    } else {
      const totalDeduction = getAmount + gasFeeInUsdt;
      return {
        totalLiquidity,
        totalDeduction,
      };
    }
  };

  const { totalLiquidity, totalDeduction, rainDeduction, usdtDeduction } = calculateValues(inputAmount);

  const getGeneratedPreviewData = async () => {
    const rawPayload = {
      poolId: poolId,
      title: question,
      accessCode: isPrivatePool ? poolAccessCode : "",
      isPrivate: isPrivatePool,
      tokenSymbol: tokenInfo?.token?.tokenLogo,
      tokenAddress: tokenInfo?.token?.tokenAddress,
      tokenName: tokenInfo?.token?.tokenName,
      volume: String(formatNumbers(+totalLiquidity || 0)),

      options:
        options?.map((option, index) => {
          const percentage = Number(barValues[index] || 0);
          return {
            optionName: option,
            totalVolume: `${Math.round(percentage)}%`,
          };
        }) || [],
    };
    const formattedPayload = preparePreviewPayload(rawPayload);
    const response = await getGeneratedPreview(formattedPayload);
    return response;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("poolType", selectedType);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  }, [selectedType]);

  const datePickerRef = useRef();
  const datePickerRef1 = useRef();
  const [month, setMonth] = useState(
    selectedStartDate && selectedStartDate.toLocaleString("en-US", { month: "long" })
  );
  const [day, setDay] = useState(selectedStartDate && selectedStartDate.getDate());
  const [year, setYear] = useState(selectedStartDate && selectedStartDate.getFullYear());
  const [hour, setHour] = useState(selectedStartDate && selectedStartDate.getHours() % 12 || 12);
  const [minute, setMinute] = useState(selectedStartDate && selectedStartDate.getMinutes());
  const [amPm, setAmPm] = useState(selectedStartDate && selectedStartDate.getHours() >= 12 ? "PM" : "AM");
  const [month1, setMonth1] = useState(
    selectedEndDate && selectedEndDate.toLocaleString("en-US", { month: "long" })
  );
  const [day1, setDay1] = useState(selectedEndDate && selectedEndDate.getDate());
  const [year1, setYear1] = useState(selectedEndDate && selectedEndDate.getFullYear());
  const [hour1, setHour1] = useState(selectedEndDate && selectedEndDate.getHours() % 12 || 12);
  const [minute1, setMinute1] = useState(selectedEndDate && selectedEndDate.getMinutes());
  const [amPm1, setAmPm1] = useState(selectedEndDate && selectedEndDate.getHours() >= 12 ? "PM" : "AM");

  // Dropdown data
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const years = Array.from({ length: 10 }, (_, i) => 2025 + i);
  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  // --- START DATE HANDLERS ---
  const updateDateFromDropdown = (m, d, y, h, min, ap) => {
    const hr24 = ap === "PM" ? (h % 12) + 12 : h % 12;
    const newDate = new Date(y, months.indexOf(m), d, hr24, min);
    setSelectedStartDate(newDate);
  };

  const onDatePickerChange = (date) => {
    setSelectedStartDate(date);
    setSelectedStartDateType(MARKET_START_DATE_TYPES.SPECIFIC)
    setMonth(date.toLocaleString("en-US", { month: "long" }));
    setDay(date.getDate());
    setYear(date.getFullYear());
    const h = date.getHours();
    setHour(h % 12 || 12);
    setAmPm(h >= 12 ? "PM" : "AM");
    setMinute(date.getMinutes());
    datePickerRef1.current.open()
  };

  // --- END DATE HANDLERS ---
  const updateDateFromDropdown1 = (m, d, y, h, min, ap) => {
    const hr24 = ap === "PM" ? (h % 12) + 12 : h % 12;
    const newDate = new Date(y, months.indexOf(m), d, hr24, min);
    setSelectedEndDate(newDate);
  };

  const onDatePickerChange1 = (date) => {
    setSelectedEndDate(date);
    setMonth1(date.toLocaleString("en-US", { month: "long" }));
    setDay1(date.getDate());
    setYear1(date.getFullYear());
    const h = date.getHours();
    setHour1(h % 12 || 12);
    setAmPm1(h >= 12 ? "PM" : "AM");
    setMinute1(date.getMinutes());
  };

  const displayStep = isPrivatePool
    ? (currentStep >= 6 ? currentStep - 1 : currentStep)
    : currentStep;

  const optionToVolumnData = async (platformKey, socialUrl) => {
    if (loadingSocialPreview) return;
    setLoadingSocialPreview(platformKey);
    try {
      await getGeneratedPreviewData()
      const message = generatePoolShareMessage(
        poolQuestion,
        poolId,
        poolAccessCode,
        isPrivatePool,
        theme,
        totalLiquidity,
        tokenInfo?.token?.tokenLogo
      );
      if (socialUrl) {
        const socialEncodedUrl = `${socialUrl}=${encodeURIComponent(message)}`;
        window.open(socialEncodedUrl, "_blank");
      }
      else {
        const emailSubject = encodeURIComponent("Check out this Market invitation!");
        const emailBody = encodeURIComponent(message);
        const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;
        window.location.href = emailUrl;
      }
    } finally {
      setLoadingSocialPreview(null);
    }
  }
  return (
    <>
      <SEO
        url={`${PUBLIC_BASE_URL}${ROUTES.CREATEPOOL}`}
      />
      {loader && <Loader />}
      <section className="publicpoll">
        <div className="custom-container">
          <div className="innerpublicpoll">
            {window.innerWidth > 991 ? (
              <div className="stepmain">
                <div className="stepinner" onClick={() => handleNextStep(1, false)}>
                  <span
                    className={`stepline ${currentStep >= 1 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 1 ? "whitepara" : ""
                      }`}
                  >
                    {t("Market Type")}
                  </p>
                </div>
                <div className="stepinner" onClick={() => handleNextStep(2, false)}>
                  <span
                    className={`stepline ${currentStep >= 2 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 2 ? "whitepara" : ""
                      }`}
                  >
                    {t("Question")}
                  </p>
                </div>
                <div className="stepinner" onClick={() => handleNextStep(3, false)}>
                  <span
                    className={`stepline ${currentStep >= 3 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 3 ? "whitepara" : ""
                      }`}
                  >
                    {t("Outcomes")}
                  </p>
                </div>
                <div className="stepinner" onClick={() => handleNextStep(4, false)}>
                  <span
                    className={`stepline ${currentStep >= 4 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 4 ? "whitepara" : ""
                      }`}
                  >
                    {t("Schedule")}
                  </p>
                </div>
                {!isPrivatePool &&
                  <div className="stepinner" onClick={() => handleNextStep(5, false)}>
                    <span
                      className={`stepline ${currentStep >= 5 ? "whiteline" : ""
                        }`}
                    ></span>
                    <p
                      className={`steppara ${currentStep >= 5 ? "whitepara" : ""
                        }`}
                    >
                      {t("Resolution Method")}
                    </p>
                  </div>}
                <div className="stepinner" onClick={() => handleNextStep(6, false)}>
                  <span
                    className={`stepline ${currentStep >= 6 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 6 ? "whitepara" : ""
                      }`}
                  >
                    {t("Add Liquidity")}
                  </p>
                </div>
                <div className="stepinner" onClick={() => handleNextStep(7, false)}>
                  <span
                    className={`stepline ${currentStep >= 7 ? "whiteline" : ""
                      }`}
                  ></span>
                  <p
                    className={`steppara ${currentStep >= 7 ? "whitepara" : ""
                      }`}
                  >
                    {t("Review & Confirm")}
                  </p>
                </div>
              </div>
            ) : (
              <div className="stepmain">
                <h6 className="stepmainhead">
                  {currentStep === 1 && <>{t("Market Type")}</>}
                  {currentStep === 2 && <> {t("Question")}</>}
                  {currentStep === 3 && <> {t("Outcomes")}</>}
                  {currentStep === 4 && <> {t("Schedule")}</>}
                  {currentStep === 5 && !isPrivatePool && <> {t("Resolution Method")}</>}
                  {currentStep === 6 && <> {t("Add Liquidity")}</>}
                  {currentStep === 7 && <> {t("Confirm and Launch")}</>}
                </h6>
                <span className="maininnersteps">{displayStep}/{!isPrivatePool ? "7" : "6"}</span>
              </div>
            )}

            {currentStep === 1 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">{t("Select Market Type")}</h6>
                    <p className="selectpara">
                      {t(
                        "Decide who can participate and view your market."
                      )}
                      <br />
                      {t(
                        "Choose public for everyone, or private for invited users"
                      )}
                    </p>
                    <h5 className="newheading">Market creators earn 1% of the market’s trading volume, with potential additional rewards for resolving the market.</h5>
                  </div>
                  <div className="selectright">
                    {is_public_live && (
                      <div
                        className={`innerselect ${selectedType === "public" ? "selected" : ""
                          }`}
                        onClick={() => setSelectedType("public")}
                        style={{ cursor: "pointer" }}
                      >
                        {selectedType === "public" ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="ticksvg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
                              fill="var(--svg-color1)"
                            />
                          </svg>
                        ) : <span className="circlebg"></span>}
                        <div className="twice-elem">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M15.5819 11.9999C15.5819 13.9799 13.9819 15.5799 12.0019 15.5799C10.0219 15.5799 8.42188 13.9799 8.42188 11.9999C8.42188 10.0199 10.0219 8.41992 12.0019 8.41992C13.9819 8.41992 15.5819 10.0199 15.5819 11.9999Z"
                              stroke="var(--svg-color1)"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.0037 20.2697C15.5337 20.2697 18.8238 18.1897 21.1138 14.5897C22.0138 13.1797 22.0138 10.8097 21.1138 9.39973C18.8238 5.79973 15.5337 3.71973 12.0037 3.71973C8.47375 3.71973 5.18375 5.79973 2.89375 9.39973C1.99375 10.8097 1.99375 13.1797 2.89375 14.5897C5.18375 18.1897 8.47375 20.2697 12.0037 20.2697Z"
                              stroke="var(--svg-color1)"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <h6 className="innerhead">{t("Public")}</h6>
                        </div>
                        <p className="innerpara">
                          {t("Public Markets can be accessed by anyone. You can choose to resolve the market yourself, or resolve it automatically by an AI Oracle.")}
                        </p>
                      </div>
                    )}
                    <div
                      className={`innerselect ${selectedType === "private" ? "selected" : ""
                        }`}
                      onClick={() => { setSelectedType("private"); setIsPublicPoolResolverAi(false) }}
                      style={{ cursor: "pointer" }}
                    >
                      {selectedType === "private" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="ticksvg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
                            fill="var(--svg-color1)"
                          />
                        </svg>
                      ) : <span className="circlebg"></span>}
                      <div className="twice-elem">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
                            stroke="var(--svg-color1)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
                            stroke="var(--svg-color1)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
                            stroke="var(--svg-color1)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <h6 className="innerhead">{t("Private")}</h6>
                      </div>
                      <p className="innerpara">
                        {t(
                          "Private Markets can only be accessed through a code and will be resolved by the creator of the Market."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {currentStep === 2 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">
                      {t("Add Your market Question")}
                    </h6>
                    <p className="selectpara">
                      {t(
                        "A good market begins with a good question. Keep it clear, factual, and verifiable. Leave no room for ambiguity or interpretation."
                      )}
                    </p>
                  </div>
                  <div className="selectrightt">
                    <p className="inputpara">{t("Market Question")}</p>
                    <input
                      className="polltextarea w-100 inputfield"

                      placeholder={t(
                        'Example: "Will the price of Bitcoin (BTC) exceed $200,000 USDT on Binance by December 31, 2026, at 23:59 UTC?"'
                      )}
                      value={question}
                      onChange={(e) => {
                        if (e.target.value.length <= 150) {
                          setQuestion(e.target.value);
                        }
                      }}
                      style={{
                        maxHeight: "52px",
                        border: errorWhileCreation && !question ? "1px solid red" : ""
                      }}
                    />
                    <div className="iferrorcomes">
                      <p className="error-text-market">{errorWhileCreation && !question ? "Question is required" : ""}</p>

                      <p className="char-text">
                        {/* {question.length} / {t("150 Characters")} */}
                        {t('Maximum 150 Characters')}
                      </p>
                    </div>
                    <p className="inputpara my-3">{t("Market Rules ")}</p>
                    <textarea
                      value={description}
                      onChange={(e) => {
                        if (e.target.value.length <= 1000) {
                          setDescription(e.target.value);
                        }
                      }}
                      className="polltextarea"
                      style={{
                        border: errorWhileCreation && !description ? "1px solid red" : "", whiteSpace: "normal"
                      }}
                      placeholder={t('Define the exact criteria that determine the winning outcome. Be specific about data sources, time zones, and edge cases to prevent disputes later.')}
                    ></textarea>
                    <div className="iferrorcomes">
                      <p className="error-text-market">{errorWhileCreation && !description ? "Description is required" : ""}</p>
                      <p className="char-text">
                        {/* {description.length} / {t("1000 Characters")} */}
                        {t('Maximum 1,000 Characters')}
                      </p>
                    </div>
                    <div className="linemain"></div>
                    <div className={errorWhileCreation && tags?.length === 0 ? "iferrorcomes-border" : ""}>
                      <p className="tagshead">
                        {t("Tags")} {" "}
                        <span className="lighttext">{t("(Required, Max 3)")}</span>
                      </p>
                      <p className="tagspara">
                        {t(
                          "Select between 1 and 3 tags that best describe your market to boost its visibility."
                        )}
                      </p>
                      {errorWhileCreation && tags?.length === 0 ? <p className="error-text-market mb-3">Please select at least 1 Tag</p> : ""}
                      <div className="spanmain">
                        {availableTags.map((tag, index) => {
                          const isSelected = tags.includes(tag);

                          return (
                            <button
                              disabled={tags?.length >= 3 && !isSelected}
                              key={index}
                              className={`spaninner ${isSelected ? "selected" : ""
                                }`}
                              onClick={() => {
                                if (isSelected) {
                                  setTags(tags.filter((t) => t !== tag));
                                } else {
                                  addTag(tag);
                                }
                              }}
                            >
                              {isSelected && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M13.3346 4L6.0013 11.3333L2.66797 8"
                                    stroke="var(--heading-text)"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                              {tag}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {currentStep === 3 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">
                      {t("Set Market Outcomes")}
                    </h6>
                    <p className="selectpara">
                      {t(
                        "Add the possible outcome options that users can choose from when participating in your market."
                      )}
                    </p>
                  </div>
                  <div className="selectright">
                    <div className="options w-100">
                      {options.map((option, index) => (
                        <div className="optionmain" key={index} >
                          <div className="option-field" style={{
                            border: errorWhileCreation && (
                              option.trim() === "" ||
                              options.some((opt, i) => i !== index && opt.trim() === option.trim())
                            ) ? "1px solid red" : "",
                            borderRadius: '8px',
                          }}>
                            <span className="circle-dot" style={{
                              background: getBackgroundColor(
                                index,
                                theme,
                                options?.length
                              ),
                            }}></span>
                            <input
                              type="text"
                              placeholder={t(`Outcome ${index + 1}`)}
                              className={option.length > 60 ? "pollinput error mb-0" : "pollinput mb-0"}
                              maxLength={60}
                              value={option}
                              onChange={(e) => {
                                updateOption(index, e.target.value.slice(0, 60));
                              }}
                              disabled={option === NONE}
                              style={{
                                cursor: option === NONE ? "not-allowed" : "text",
                              }}
                            />
                            {index > 1 && option !== NONE ? (
                              <a
                                onClick={() => deleteOption(index)}
                                className="btn-delete"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                  <g clip-path="url(#clip0_207_3650)">
                                    <path d="M1.45801 3.51562L2.08072 11.0329C2.12534 11.575 2.58711 12 3.13128 12H8.8689C9.41307 12 9.87484 11.575 9.91946 11.0329L10.5422 3.51562H1.45801ZM4.24194 10.5938C4.05791 10.5938 3.90308 10.4506 3.89141 10.2641L3.53984 4.59227C3.52782 4.3983 3.6751 4.23145 3.86874 4.21943C4.06958 4.20534 4.22923 4.35436 4.24159 4.54833L4.59315 10.2202C4.60559 10.4211 4.44666 10.5938 4.24194 10.5938ZM6.35164 10.2422C6.35164 10.4365 6.1944 10.5938 6.00008 10.5938C5.80576 10.5938 5.64852 10.4365 5.64852 10.2422V4.57031C5.64852 4.37599 5.80576 4.21875 6.00008 4.21875C6.1944 4.21875 6.35164 4.37599 6.35164 4.57031V10.2422ZM8.46031 4.5923L8.10875 10.2642C8.0972 10.4487 7.94338 10.6025 7.73591 10.5931C7.54227 10.581 7.39499 10.4142 7.40701 10.2202L7.75857 4.54835C7.77059 4.35438 7.94054 4.21327 8.13141 4.21945C8.32506 4.23148 8.47234 4.39833 8.46031 4.5923Z" fill="#FE5C32" />
                                    <path d="M10.5703 1.40625H8.46094V1.05469C8.46094 0.473109 7.98783 0 7.40625 0H4.59375C4.01217 0 3.53906 0.473109 3.53906 1.05469V1.40625H1.42969C1.04135 1.40625 0.726562 1.72104 0.726562 2.10938C0.726562 2.49766 1.04135 2.8125 1.42969 2.8125C4.66327 2.8125 7.33685 2.8125 10.5703 2.8125C10.9586 2.8125 11.2734 2.49766 11.2734 2.10938C11.2734 1.72104 10.9586 1.40625 10.5703 1.40625ZM7.75781 1.40625H4.24219V1.05469C4.24219 0.860719 4.39978 0.703125 4.59375 0.703125H7.40625C7.60022 0.703125 7.75781 0.860719 7.75781 1.05469V1.40625Z" fill="#FE5C32" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_207_3650">
                                      <rect width="12" height="12" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </a>
                            ) : (
                              ""
                            )}
                            {
                              option === NONE && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                      <p>This is a mandatory fallback. It wins only if the event is canceled, the rules are ambiguous, or the result doesn't match any of the options you listed.</p>
                                    </TooltipCustom>
                                  }
                                >
                                  <svg className="unclassified-tooltip" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_10136_49160)">
                                      <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_10136_49160">
                                        <rect width="14" height="14" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </OverlayTrigger>
                              )
                            }
                          </div>
                          {
                            option != NONE && (
                              <p className="char-text">Maximum 60 Characters</p>
                            )
                          }
                          {index === options.length - 2 && errorWhileCreation && (
                            <p className="error-text-market">
                              {errorMessageWhileCreation}
                            </p>
                          )}
                        </div>
                      ))}
                      {/* {errorWhileCreation ? <p className="error-text-market">{errorMessageWhileCreation}</p> : ""} */}
                      {/* <div className="bluemain">
                        {t(
                          "The unclassified outcome is a system-defined fallback and cannot be edited or removed."
                        )}
                        "
                      </div> */}
                    </div>
                    {options.length >= 26 ? "" : <button className="addoptionbtn" onClick={addOption}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M8 1C6.15046 1.02244 4.38299 1.76714 3.07507 3.07507C1.76714 4.38299 1.02244 6.15046 1 8C1.02244 9.84954 1.76714 11.617 3.07507 12.9249C4.38299 14.2329 6.15046 14.9776 8 15C9.84954 14.9776 11.617 14.2329 12.9249 12.9249C14.2329 11.617 14.9776 9.84954 15 8C14.9776 6.15046 14.2329 4.38299 12.9249 3.07507C11.617 1.76714 9.84954 1.02244 8 1ZM12 8.5H8.5V12H7.5V8.5H4V7.5H7.5V4H8.5V7.5H12V8.5Z"
                          fill="#dad9d9"
                        />
                      </svg>
                      {t("Add option")}
                    </button>}

                  </div>
                </div>
              </>
            )}
            {currentStep === 4 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">
                      {t("Set Market Schedule")}
                    </h6>
                    <p className="selectpara">
                      {t(
                        "Control when your market goes live and when new predictions must stop. Note that trading continues on the secondary market until the final resolution."
                      )}
                    </p>
                  </div>
                  <div className="selectright">
                    <div className="new-timer-parent">
                      <div className="upper-head">
                        <h6>Start Time</h6>
                        <p>The time when the market will go live and users can start making predictions.</p>
                      </div>
                      <div className="start-timer">
                        <div className="single-time">
                          <div className="twice-elem">
                            <label class="radio-item">
                              <input
                                type="radio"
                                name="customRadio"
                                checked={selectedStartDateType === MARKET_START_DATE_TYPES.CURRENT}
                                onChange={() => { setSelectedStartDateType(MARKET_START_DATE_TYPES.CURRENT); setSelectedStartDate("") }}
                              />
                              <span class="custom-radio"></span>
                            </label>
                            <h6>Launch now</h6>
                          </div>
                        </div>
                        <div className="single-time" onClick={() => datePickerRef.current?.open()}>
                          <div className="twice-elem">
                            <label class="radio-item">
                              <input
                                type="radio"
                                name="customRadio"
                                checked={selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC}
                                onChange={() => setSelectedStartDateType(MARKET_START_DATE_TYPES.SPECIFIC)}
                              />
                              <span class="custom-radio"></span>
                            </label>
                            <p style={{ fontFamily: selectedStartDate ? "hbold" : "400", color: selectedStartDate ? "var(--text-color1)" : "var(--para)" }}>{selectedStartDateType === MARKET_START_DATE_TYPES.SPECIFIC ? displayValue : "Pick a date and time"} </p>
                          </div>
                          <svg className="caledndarsvg"
                            style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path d="M13.8125 2.125H12.2188V1.59375C12.2188 1.45285 12.1628 1.31773 12.0632 1.2181C11.9635 1.11847 11.8284 1.0625 11.6875 1.0625C11.5466 1.0625 11.4115 1.11847 11.3118 1.2181C11.2122 1.31773 11.1562 1.45285 11.1562 1.59375V2.125H5.84375V1.59375C5.84375 1.45285 5.78778 1.31773 5.68815 1.2181C5.58852 1.11847 5.4534 1.0625 5.3125 1.0625C5.1716 1.0625 5.03648 1.11847 4.93685 1.2181C4.83722 1.31773 4.78125 1.45285 4.78125 1.59375V2.125H3.1875C2.90571 2.125 2.63546 2.23694 2.4362 2.4362C2.23694 2.63546 2.125 2.90571 2.125 3.1875V13.8125C2.125 14.0943 2.23694 14.3645 2.4362 14.5638C2.63546 14.7631 2.90571 14.875 3.1875 14.875H13.8125C14.0943 14.875 14.3645 14.7631 14.5638 14.5638C14.7631 14.3645 14.875 14.0943 14.875 13.8125V3.1875C14.875 2.90571 14.7631 2.63546 14.5638 2.4362C14.3645 2.23694 14.0943 2.125 13.8125 2.125ZM4.78125 3.1875V3.71875C4.78125 3.85965 4.83722 3.99477 4.93685 4.0944C5.03648 4.19403 5.1716 4.25 5.3125 4.25C5.4534 4.25 5.58852 4.19403 5.68815 4.0944C5.78778 3.99477 5.84375 3.85965 5.84375 3.71875V3.1875H11.1562V3.71875C11.1562 3.85965 11.2122 3.99477 11.3118 4.0944C11.4115 4.19403 11.5466 4.25 11.6875 4.25C11.8284 4.25 11.9635 4.19403 12.0632 4.0944C12.1628 3.99477 12.2188 3.85965 12.2188 3.71875V3.1875H13.8125V5.3125H3.1875V3.1875H4.78125ZM13.8125 13.8125H3.1875V6.375H13.8125V13.8125ZM9.29688 8.76562C9.29688 8.92323 9.25014 9.0773 9.16258 9.20834C9.07502 9.33939 8.95056 9.44153 8.80495 9.50184C8.65934 9.56215 8.49912 9.57794 8.34454 9.54719C8.18996 9.51644 8.04797 9.44055 7.93652 9.3291C7.82508 9.21766 7.74918 9.07567 7.71844 8.92109C7.68769 8.76651 7.70347 8.60628 7.76378 8.46067C7.8241 8.31506 7.92623 8.19061 8.05728 8.10305C8.18833 8.01549 8.34239 7.96875 8.5 7.96875C8.71134 7.96875 8.91403 8.05271 9.06348 8.20215C9.21292 8.35159 9.29688 8.55428 9.29688 8.76562ZM12.2188 8.76562C12.2188 8.92323 12.172 9.0773 12.0845 9.20834C11.9969 9.33939 11.8724 9.44153 11.7268 9.50184C11.5812 9.56215 11.421 9.57794 11.2664 9.54719C11.1118 9.51644 10.9698 9.44055 10.8584 9.3291C10.747 9.21766 10.6711 9.07567 10.6403 8.92109C10.6096 8.76651 10.6253 8.60628 10.6857 8.46067C10.746 8.31506 10.8481 8.19061 10.9792 8.10305C11.1102 8.01549 11.2643 7.96875 11.4219 7.96875C11.6332 7.96875 11.8359 8.05271 11.9854 8.20215C12.1348 8.35159 12.2188 8.55428 12.2188 8.76562ZM6.375 11.4219C6.375 11.5795 6.32826 11.7335 6.2407 11.8646C6.15314 11.9956 6.02869 12.0978 5.88308 12.1581C5.73747 12.2184 5.57724 12.2342 5.42266 12.2034C5.26808 12.1727 5.12609 12.0968 5.01465 11.9854C4.9032 11.8739 4.82731 11.7319 4.79656 11.5773C4.76581 11.4228 4.78159 11.2625 4.84191 11.1169C4.90222 10.9713 5.00436 10.8469 5.13541 10.7593C5.26645 10.6717 5.42052 10.625 5.57812 10.625C5.78947 10.625 5.99216 10.709 6.1416 10.8584C6.29104 11.0078 6.375 11.2105 6.375 11.4219ZM9.29688 11.4219C9.29688 11.5795 9.25014 11.7335 9.16258 11.8646C9.07502 11.9956 8.95056 12.0978 8.80495 12.1581C8.65934 12.2184 8.49912 12.2342 8.34454 12.2034C8.18996 12.1727 8.04797 12.0968 7.93652 11.9854C7.82508 11.8739 7.74918 11.7319 7.71844 11.5773C7.68769 11.4228 7.70347 11.2625 7.76378 11.1169C7.8241 10.9713 7.92623 10.8469 8.05728 10.7593C8.18833 10.6717 8.34239 10.625 8.5 10.625C8.71134 10.625 8.91403 10.709 9.06348 10.8584C9.21292 11.0078 9.29688 11.2105 9.29688 11.4219ZM12.2188 11.4219C12.2188 11.5795 12.172 11.7335 12.0845 11.8646C11.9969 11.9956 11.8724 12.0978 11.7268 12.1581C11.5812 12.2184 11.421 12.2342 11.2664 12.2034C11.1118 12.1727 10.9698 12.0968 10.8584 11.9854C10.747 11.8739 10.6711 11.7319 10.6403 11.5773C10.6096 11.4228 10.6253 11.2625 10.6857 11.1169C10.746 10.9713 10.8481 10.8469 10.9792 10.7593C11.1102 10.6717 11.2643 10.625 11.4219 10.625C11.6332 10.625 11.8359 10.709 11.9854 10.8584C12.1348 11.0078 12.2188 11.2105 12.2188 11.4219Z" fill="#212121" />
                          </svg>
                          <DateTimePicker
                            ref={datePickerRef}
                            onChange={onDatePickerChange}
                            value={selectedStartDate}
                            minDateTime={new Date()}
                            placeholder="dd/MM/yyyy hh:mm"
                            format="dd/MM/yyyy hh:mm aa"
                            oneTap={false}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <div className="upper-head endtimer-head">
                        <h6>End Time</h6>
                        <p>After this time, no new predictions can be created. Users can only buy or sell shares that already exist.</p>
                      </div>
                      <div className="end-timer" onClick={() => datePickerRef1.current.open()} style={{
                        border: errorWhileCreation && !selectedEndDate ? "1px solid red" : ""
                      }}>
                        <p style={{ fontFamily: selectedEndDate ? "hbold" : "400", color: selectedEndDate ? "var(--text-color1)" : "var(--para)" }}>{displayEndValue}</p>
                        <svg className="caledndarsvg"
                          style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                          <path d="M13.8125 2.125H12.2188V1.59375C12.2188 1.45285 12.1628 1.31773 12.0632 1.2181C11.9635 1.11847 11.8284 1.0625 11.6875 1.0625C11.5466 1.0625 11.4115 1.11847 11.3118 1.2181C11.2122 1.31773 11.1562 1.45285 11.1562 1.59375V2.125H5.84375V1.59375C5.84375 1.45285 5.78778 1.31773 5.68815 1.2181C5.58852 1.11847 5.4534 1.0625 5.3125 1.0625C5.1716 1.0625 5.03648 1.11847 4.93685 1.2181C4.83722 1.31773 4.78125 1.45285 4.78125 1.59375V2.125H3.1875C2.90571 2.125 2.63546 2.23694 2.4362 2.4362C2.23694 2.63546 2.125 2.90571 2.125 3.1875V13.8125C2.125 14.0943 2.23694 14.3645 2.4362 14.5638C2.63546 14.7631 2.90571 14.875 3.1875 14.875H13.8125C14.0943 14.875 14.3645 14.7631 14.5638 14.5638C14.7631 14.3645 14.875 14.0943 14.875 13.8125V3.1875C14.875 2.90571 14.7631 2.63546 14.5638 2.4362C14.3645 2.23694 14.0943 2.125 13.8125 2.125ZM4.78125 3.1875V3.71875C4.78125 3.85965 4.83722 3.99477 4.93685 4.0944C5.03648 4.19403 5.1716 4.25 5.3125 4.25C5.4534 4.25 5.58852 4.19403 5.68815 4.0944C5.78778 3.99477 5.84375 3.85965 5.84375 3.71875V3.1875H11.1562V3.71875C11.1562 3.85965 11.2122 3.99477 11.3118 4.0944C11.4115 4.19403 11.5466 4.25 11.6875 4.25C11.8284 4.25 11.9635 4.19403 12.0632 4.0944C12.1628 3.99477 12.2188 3.85965 12.2188 3.71875V3.1875H13.8125V5.3125H3.1875V3.1875H4.78125ZM13.8125 13.8125H3.1875V6.375H13.8125V13.8125ZM9.29688 8.76562C9.29688 8.92323 9.25014 9.0773 9.16258 9.20834C9.07502 9.33939 8.95056 9.44153 8.80495 9.50184C8.65934 9.56215 8.49912 9.57794 8.34454 9.54719C8.18996 9.51644 8.04797 9.44055 7.93652 9.3291C7.82508 9.21766 7.74918 9.07567 7.71844 8.92109C7.68769 8.76651 7.70347 8.60628 7.76378 8.46067C7.8241 8.31506 7.92623 8.19061 8.05728 8.10305C8.18833 8.01549 8.34239 7.96875 8.5 7.96875C8.71134 7.96875 8.91403 8.05271 9.06348 8.20215C9.21292 8.35159 9.29688 8.55428 9.29688 8.76562ZM12.2188 8.76562C12.2188 8.92323 12.172 9.0773 12.0845 9.20834C11.9969 9.33939 11.8724 9.44153 11.7268 9.50184C11.5812 9.56215 11.421 9.57794 11.2664 9.54719C11.1118 9.51644 10.9698 9.44055 10.8584 9.3291C10.747 9.21766 10.6711 9.07567 10.6403 8.92109C10.6096 8.76651 10.6253 8.60628 10.6857 8.46067C10.746 8.31506 10.8481 8.19061 10.9792 8.10305C11.1102 8.01549 11.2643 7.96875 11.4219 7.96875C11.6332 7.96875 11.8359 8.05271 11.9854 8.20215C12.1348 8.35159 12.2188 8.55428 12.2188 8.76562ZM6.375 11.4219C6.375 11.5795 6.32826 11.7335 6.2407 11.8646C6.15314 11.9956 6.02869 12.0978 5.88308 12.1581C5.73747 12.2184 5.57724 12.2342 5.42266 12.2034C5.26808 12.1727 5.12609 12.0968 5.01465 11.9854C4.9032 11.8739 4.82731 11.7319 4.79656 11.5773C4.76581 11.4228 4.78159 11.2625 4.84191 11.1169C4.90222 10.9713 5.00436 10.8469 5.13541 10.7593C5.26645 10.6717 5.42052 10.625 5.57812 10.625C5.78947 10.625 5.99216 10.709 6.1416 10.8584C6.29104 11.0078 6.375 11.2105 6.375 11.4219ZM9.29688 11.4219C9.29688 11.5795 9.25014 11.7335 9.16258 11.8646C9.07502 11.9956 8.95056 12.0978 8.80495 12.1581C8.65934 12.2184 8.49912 12.2342 8.34454 12.2034C8.18996 12.1727 8.04797 12.0968 7.93652 11.9854C7.82508 11.8739 7.74918 11.7319 7.71844 11.5773C7.68769 11.4228 7.70347 11.2625 7.76378 11.1169C7.8241 10.9713 7.92623 10.8469 8.05728 10.7593C8.18833 10.6717 8.34239 10.625 8.5 10.625C8.71134 10.625 8.91403 10.709 9.06348 10.8584C9.21292 11.0078 9.29688 11.2105 9.29688 11.4219ZM12.2188 11.4219C12.2188 11.5795 12.172 11.7335 12.0845 11.8646C11.9969 11.9956 11.8724 12.0978 11.7268 12.1581C11.5812 12.2184 11.421 12.2342 11.2664 12.2034C11.1118 12.1727 10.9698 12.0968 10.8584 11.9854C10.747 11.8739 10.6711 11.7319 10.6403 11.5773C10.6096 11.4228 10.6253 11.2625 10.6857 11.1169C10.746 10.9713 10.8481 10.8469 10.9792 10.7593C11.1102 10.6717 11.2643 10.625 11.4219 10.625C11.6332 10.625 11.8359 10.709 11.9854 10.8584C12.1348 11.0078 12.2188 11.2105 12.2188 11.4219Z" fill="#212121" />
                        </svg>
                        <DateTimePicker
                          ref={datePickerRef1}
                          onChange={onDatePickerChange1}
                          value={selectedEndDate}
                          minDateTime={selectedStartDate ? selectedStartDate : new Date()}
                          placeholder="dd/MM/yyyy hh:mm"
                          format="dd/MM/yyyy hh:mm aa"
                          oneTap={false}
                          style={{ display: "none" }}
                        />
                      </div>
                      {errorWhileCreation && !selectedEndDate && (
                        <p className="error-text-market">
                          {errorMessageWhileCreation}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {currentStep === 5 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">
                      {t("Select Resolution Method")}
                    </h6>
                    <p className="selectpara">
                      {t(
                        "Choose how the final result will be determined. Use the AI Oracle for automated verification, or resolve the market manually by proposing the outcome and earn additional rewards if your resolution becomes final."
                      )}
                    </p>
                  </div>
                  <div className="selectrightt">
                    <div className="resolution-parent">
                      <div
                        className={`single-resolution ${isPublicPoolResolverAi ? "active" : ""
                          }`}
                        onClick={() => setIsPublicPoolResolverAi(true)}
                        style={{ cursor: "pointer" }}
                      >
                        {isPublicPoolResolverAi ? (
                          <svg
                            className="checkmark"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
                              fill="var(--svg-color1)"
                            />
                          </svg>
                        ) : <span className="circle-dot"></span>}
                        <div className="twice-elem">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.8518 14.7715L10.4688 15.6945" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.8518 9.22769L10.4688 8.30469" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.1484 14.7715L13.5304 15.6955" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.5314 8.30469L13.1484 9.22769" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14.7734 10.8518L15.6964 10.4688" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14.7734 13.1484L15.6964 13.5314" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M17.5995 6.50076C17.8296 6.10224 17.965 5.65614 17.9951 5.19695C18.0252 4.73776 17.9493 4.2778 17.7732 3.85265C17.5971 3.4275 17.3255 3.04855 16.9796 2.74513C16.6336 2.44171 16.2225 2.22195 15.778 2.10285C15.3335 1.98375 14.8675 1.96849 14.4162 2.05827C13.9649 2.14805 13.5402 2.34046 13.1752 2.6206C12.8101 2.90075 12.5144 3.26112 12.3108 3.67384C12.1073 4.08657 12.0015 4.54058 12.0015 5.00076C12.0021 4.33455 11.7809 3.68709 11.3729 3.16049C10.9648 2.63388 10.3931 2.25808 9.7478 2.09236C9.10253 1.92663 8.42046 1.9804 7.80913 2.24518C7.19781 2.50997 6.69201 2.97071 6.3715 3.55476C6.10767 4.03499 5.9804 4.57831 6.0035 5.12576C5.41565 5.27697 4.86992 5.55999 4.40766 5.95337C3.9454 6.34675 3.57872 6.84018 3.33541 7.39627C3.09211 7.95236 2.97855 8.55653 3.00334 9.16301C3.02813 9.76949 3.19062 10.3624 3.4785 10.8968" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18 5.125C18.5879 5.27622 19.1336 5.55923 19.5958 5.95261C20.0581 6.34599 20.4248 6.83942 20.6681 7.39551C20.9114 7.9516 21.025 8.55577 21.0002 9.16225C20.9754 9.76874 20.8129 10.3616 20.525 10.896" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.5078 10.2949C20.367 10.6439 21.0783 11.2805 21.5199 12.096C21.9615 12.9114 22.1061 13.8549 21.9289 14.7652C21.7518 15.6755 21.2638 16.4959 20.5485 17.0861C19.8333 17.6763 18.9352 17.9997 18.0078 18.0009" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.03398 17.4824C3.9136 18.4001 4.1152 19.3312 4.60443 20.1169C5.09367 20.9027 5.84024 21.4944 6.71691 21.7913C7.59358 22.0882 8.54609 22.0719 9.41208 21.7451C10.2781 21.4184 11.0039 20.8014 11.466 19.9994C11.646 19.6884 12.358 19.6884 12.538 19.9994C13 20.8013 13.7258 21.4181 14.5917 21.7448C15.4575 22.0715 16.4099 22.0879 17.2864 21.7912C18.163 21.4944 18.9096 20.9029 19.3989 20.1174C19.8882 19.3319 20.0901 18.401 19.97 17.4834" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.50224 10.291C3.64113 10.6387 2.92784 11.2753 2.48473 12.0914C2.04161 12.9075 1.89627 13.8524 2.07364 14.764C2.25102 15.6756 2.74004 16.497 3.45685 17.0875C4.17365 17.6779 5.07357 18.0005 6.00224 18" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6 5.125C6.02039 5.6089 6.15763 6.08068 6.4 6.5" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.22769 10.8518L8.30469 10.4688" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.22769 13.1484L8.30469 13.5314" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <h6>{t("AI-Powered Resolution")} <span>(Recommended)</span></h6>
                        </div>
                        <div className="text">
                          <p>
                            {t(
                              "The AI Oracle verifies the result across multiple data sources to automatically resolve the market."
                            )}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                  <p>Requirement: Your Question and Rules must be strictly fact-based and unambiguous for the AI to validate the outcome.</p>
                                </TooltipCustom>
                              }
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <g clip-path="url(#clip0_10136_49160)">
                                  <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_10136_49160">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </OverlayTrigger>
                          </p>
                        </div>
                        <div className="twice-inline">
                          <p>{t("Powered By")}</p>
                          <img
                            src={
                              theme === "dark"
                                ? "/assets/olympuslogo.svg"
                                : "/assets/olympuslogolight.svg"
                            }
                            alt="img"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      <div
                        className={`single-resolution ${!isPublicPoolResolverAi ? "active" : ""
                          }`}
                        onClick={() => setIsPublicPoolResolverAi(false)}
                        style={{ cursor: "pointer" }}
                      >
                        {!isPublicPoolResolverAi ? (
                          <svg
                            className="checkmark"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
                              fill="var(--svg-color1)"
                            />
                          </svg>
                        ) : <span className="circle-dot"></span>}
                        <div className="twice-elem">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="var(--svg-color1)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <h6>{t("Manual Resolution")}</h6>
                        </div>
                        <div className="text">

                          <p>
                            {t(
                              "You determine the final outcome. If no dispute occurs, you may earn the 0.1% resolver fee."
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {currentStep === 6 && (
              <>
                <div className="mainselect">
                  <div className="selectleft">
                    <h6 className="selecthead">{t("Set Liquidity & Probabilities")}</h6>
                    <p className="selectpara">
                      {t(
                        "Specify the liquidity amount you intend to add and set the starting probability for each outcome."
                      )}
                    </p>
                    <h5 className="newheading">Note: The actual transaction occurs only at the final confirmation step.</h5>
                  </div>
                  <div className="selectrightt">
                    <div className="add-liquidity-head">
                      <h6>Initial Liquidity</h6>
                      <p className="balancepara">
                        {t("Balance")}:{" "}
                        {getTokenSymbol(tokenSymbol, true)}  {handleToFixedOnDecimals(selectedToken === TOKEN_RAIN ? smartAccountRainBalance : stableBalance)}
                      </p>
                    </div>
                    <div className={errorWhileCreation && (!inputAmount || (+inputAmount) < minimumLiquidity) ? "liquiditymaininput mb-0 error" : "liquiditymaininput mb-0"}>
                      <div className="leftinput"  >
                        {maxButtonSpinner ? (
                          <span
                            className="spinner m-0"
                            style={{ width: "10px", height: "10px" }}
                          />
                        ) : (
                          <input
                            type="number"
                            inputMode="numeric"
                            className="innerinput"
                            placeholder="0.00"
                            value={inputAmount > 0 ? formatSmartDecimal(+inputAmount) : ""}
                            onChange={(e) => handleInputChange(e?.target?.value, false)}
                            onBlur={handleCheckLiquidityAmount}
                            style={{ color: "#FE5C32" }}
                          />
                        )}

                        {selectedToken === TOKEN_RAIN ?
                          <p className="balancepara">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M14.0001 10.6667L11.3334 13.3334L8.66675 10.6667" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M11.3333 13.3334V2.66669" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M2 5.33335L4.66667 2.66669L7.33333 5.33335" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M4.66675 2.66669V13.3334" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            ${handleToFixedOnDecimals(+inputAmount * +rainPriceToUsdt)}
                          </p> : ""}
                      </div>
                      <div className="rightinput">
                        <div className="rain-incentive">
                          <div className="twice-items">
                            <button className="maxbtn" onClick={() => handleInputChange(selectedToken === TOKEN_RAIN ? smartAccountRainBalance : stableBalance, true)}>{t("MAX")}</button>
                            <Dropdown className="tokendropdown">
                              <Dropdown.Toggle id="dropdown-basic">
                                <div className="tokenmain">
                                  <div className="tokenmainimg">
                                    <img src={MARKET_TOKEN[selectedToken]?.icon} alt="img" className="img-fluid tokeninnerimg" />
                                  </div>
                                  {MARKET_TOKEN[selectedToken]?.label}   </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M12.8667 6.71141L8.32157 10.8778C8.27936 10.9165 8.22923 10.9473 8.17405 10.9682C8.11887 10.9892 8.05973 11 8 11C7.94027 11 7.88113 10.9892 7.82595 10.9682C7.77077 10.9473 7.72064 10.9165 7.67843 10.8778L3.1333 6.71141C3.06967 6.65314 3.02632 6.57888 3.00875 6.49801C2.99119 6.41715 3.00019 6.33333 3.03462 6.25715C3.06905 6.18098 3.12736 6.11589 3.20217 6.07011C3.27698 6.02434 3.36492 5.99994 3.45487 6H12.5451C12.6351 5.99994 12.723 6.02434 12.7978 6.07011C12.8726 6.11589 12.931 6.18098 12.9654 6.25715C12.9998 6.33333 13.0088 6.41715 12.9912 6.49801C12.9737 6.57888 12.9303 6.65314 12.8667 6.71141Z" fill="#212121" />
                                </svg>
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="dropdown-menu">
                                <Dropdown.Item onClick={() => { setSelectedToken(TOKEN_USDR); setInputAmount(''); setErrorWhileCreation(false) }} className="dropdown-item"><div className="tokenmain"><img src={MARKET_TOKEN.USDR.icon} alt="img" className="img-fluid tokenmainimg" /> {MARKET_TOKEN.USDR.label}</div></Dropdown.Item>
                                {/* No new USDT markets; existing USDT markets still trade in USDT */}
                                <Dropdown.Item onClick={() => { setSelectedToken(TOKEN_RAIN); setInputAmount(''); setErrorWhileCreation(false) }} className="dropdown-item"><div className="tokenmain"><img src="\assets\rain-icon.svg" alt="img" className="img-fluid tokenmainimg" /> RAIN</div></Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>

                        </div>
                      </div>
                    </div>
                    {errorWhileCreation && (!inputAmount || (+inputAmount) < minimumLiquidity) ? <p className="error-text-market" style={{ marginTop: "14px" }}>Liquidity value is too low. <span>Set amount to minimum {minLiquidityDisplay}</span></p> : ""}
                    <div className="multi-text">
                      <h6>Net Liquidity</h6>
                      <p>Final amount added after subtracting all fees.</p>
                    </div>
                    <Accordion className="summaryacc">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          {!inputAmount || ((+inputAmount) - (+oracleFixedFee)) <= 0 ? "0" : selectedToken === TOKEN_RAIN ? (
                            <>
                              {getTokenSymbol(TOKEN_RAIN)}{handleToFixedOnDecimals((+inputAmount) - (+oracleFixedFee))}
                            </>
                          ) : (
                            <>
                              {!gasFeesSpinner ? (
                                <>
                                  {getTokenSymbol(tokenSymbol)}
                                  {handleToFixedOnDecimals((+inputAmount) - (+oracleFixedFee))}
                                </>
                              ) : "..."}
                            </>
                          )}</Accordion.Header>
                        <Accordion.Body>
                          <div className="liquidity-detail">
                            <div className="single-text">
                              <p>{t(`Estimated ${NETWORK_FEES}`)} <OverlayTrigger
                                placement="top"
                                overlay={
                                  <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                    <h6>Blockchain transaction fee. Charged separately from your wallet.</h6>
                                  </TooltipCustom>
                                }
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <g clip-path="url(#clip0_10136_49160)">
                                    <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_10136_49160">
                                      <rect width="14" height="14" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </OverlayTrigger></p>
                              <h6>
                                {gasFeesSpinner ? (
                                  <span
                                    className="spinner m-0"
                                    style={{ width: "10px", height: "10px" }}
                                  />
                                ) : (
                                  `$${gasFeeInUsdt?.toFixed(4)}`
                                )}
                              </h6>
                            </div>
                            <div className="single-text">
                              <p>{t("Oracle Fixed Fee")} <OverlayTrigger
                                placement="top"
                                overlay={
                                  <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                    <h6> Fixed fee for market resolution. Deducted from your entered amount.</h6>
                                  </TooltipCustom>
                                }
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <g clip-path="url(#clip0_10136_49160)">
                                    <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_10136_49160">
                                      <rect width="14" height="14" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </OverlayTrigger></p>
                              <h6>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(oracleFixedFee)}</h6>
                            </div>
                            {/* <div className="single-text">
                              <p>{t("Minimum Liquidity")}</p>
                              <h6>{getTokenSymbol(tokenSymbol)}{formatNumbers(+minimumLiquidity)}</h6>
                            </div> */}
                            {inputAmount > 0 && (
                              <>
                                {/* <div className="single-text">
                                  <p>{t("Total Liquidity")}</p>
                                  <h6>{getTokenSymbol(tokenSymbol)}{+totalLiquidity?.toFixed(4)}</h6>
                                </div> */}
                                <div className="single-text">
                                  <p style={{ color: "var(--text-color1)", fontFamily: "hbold" }}>{t("Total Deduction")}</p>
                                  <h6 style={{ color: "var(--green-text)" }}>
                                    {selectedToken === TOKEN_RAIN ? (
                                      <>
                                        {getTokenSymbol(TOKEN_RAIN)}{formatNumbers(+rainDeduction)} + ${formatNumbers(+usdtDeduction)}
                                      </>
                                    ) : (
                                      <>
                                        {getTokenSymbol(tokenSymbol)}{formatNumbers(+totalDeduction)}
                                      </>
                                    )}
                                  </h6>
                                </div>
                              </>
                            )}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <p className="para-box">
                      The amount you specify is automatically distributed across all outcome options based on the probabilities set below.
                    </p>
                    <div className="newpart-add">
                      <div className="inside-scroll">
                        {options.map((option, index) => (
                          <div
                            className="single-part"
                            key={index}
                            style={{
                              opacity:
                                inputAmount <= 0 || inputAmount < minimumLiquidity
                                  ? 1
                                  : 1,
                              pointerEvents:
                                inputAmount <= 0 || inputAmount < minimumLiquidity
                                  ? "none"
                                  : "auto",
                            }}
                          >
                            <div
                              className="main-head-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <h6 className="main-head">
                                <span
                                  style={{
                                    background: getBackgroundColor(
                                      index,
                                      theme,
                                      options?.length
                                    ),
                                  }}
                                ></span>
                                <span className="texxt-option">{option}</span>
                              </h6>
                            </div>
                            <div className="bottom-twice">
                              <div className="progress-custom">
                                <p>1%</p>
                                <div className="slider-container">
                                  <input
                                    type="range"
                                    min="1"
                                    max="100"
                                    step="0.1"
                                    value={barValues[index]}
                                    onChange={(e) => handleChange(e, index)}
                                    className="custom-slider"
                                    style={{
                                      background:
                                        barValues[index] > 1
                                          ? `linear-gradient(to right, ${getBackgroundColor(
                                            index,
                                            theme,
                                            options?.length
                                          )} ${barValues[index]
                                          }%, var(--background14) ${barValues[index]
                                          }%)`
                                          : "var(--background14)",
                                      "--thumb-color": getBackgroundColor(
                                        index,
                                        theme,
                                        options?.length
                                      ),
                                      opacity: lockedBars[index] ? 0.7 : 1,
                                      cursor: lockedBars[index]
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                    disabled={lockedBars[index]}
                                  />
                                </div>
                                <p>100%</p>
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <input
                                  type="number"
                                  inputMode="numeric"
                                  value={
                                    barValues[index] !== ""
                                      ? Number(barValues[index]).toFixed(0)
                                      : ""
                                  }
                                  onChange={(e) => handleInputChange3(e, index)}
                                  className="value-shown"
                                  min={0}
                                  max={100}
                                  step="0.1"
                                  style={{
                                    paddingRight: "15px",
                                    opacity: lockedBars[index] ? 0.7 : 1,
                                    cursor: lockedBars[index]
                                      ? "not-allowed"
                                      : "text",
                                  }}
                                  disabled={lockedBars[index]}
                                />

                                <span
                                  className="percent_sign"
                                  style={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  %
                                </span>
                              </div>
                              {option !== NONE && (
                                <button
                                  onClick={() => toggleLock(index)}
                                  className="lock-button "
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: "5px",
                                    fontSize: "24px",
                                  }}
                                >
                                  {lockedBars[index] ? (
                                    <>
                                      <div className="lock-style">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.25 6.25H13.75V4.375C13.75 3.38044 13.3549 2.42661 12.6517 1.72335C11.9484 1.02009 10.9946 0.625 10 0.625C9.00544 0.625 8.05161 1.02009 7.34835 1.72335C6.64509 2.42661 6.25 3.38044 6.25 4.375V6.25H3.75C3.41848 6.25 3.10054 6.3817 2.86612 6.61612C2.6317 6.85054 2.5 7.16848 2.5 7.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V7.5C17.5 7.16848 17.3683 6.85054 17.1339 6.61612C16.8995 6.3817 16.5815 6.25 16.25 6.25ZM7.5 4.375C7.5 3.71196 7.76339 3.07607 8.23223 2.60723C8.70107 2.13839 9.33696 1.875 10 1.875C10.663 1.875 11.2989 2.13839 11.7678 2.60723C12.2366 3.07607 12.5 3.71196 12.5 4.375V6.25H7.5V4.375ZM16.25 16.25H3.75V7.5H16.25V16.25ZM10.9375 11.875C10.9375 12.0604 10.8825 12.2417 10.7795 12.3958C10.6765 12.55 10.5301 12.6702 10.3588 12.7411C10.1875 12.8121 9.99896 12.8307 9.8171 12.7945C9.63525 12.7583 9.4682 12.669 9.33709 12.5379C9.20598 12.4068 9.11669 12.2398 9.08051 12.0579C9.04434 11.876 9.06291 11.6875 9.13386 11.5162C9.20482 11.3449 9.32498 11.1985 9.47915 11.0955C9.63332 10.9925 9.81458 10.9375 10 10.9375C10.2486 10.9375 10.4871 11.0363 10.6629 11.2121C10.8387 11.3879 10.9375 11.6264 10.9375 11.875Z"
                                            fill="#DAD9D9"
                                          />
                                        </svg>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="lock-style">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M16.25 6.25H7.5V4.375C7.5 3.71196 7.76339 3.07607 8.23223 2.60723C8.70107 2.13839 9.33696 1.875 10 1.875C11.2008 1.875 12.2812 2.73438 12.5125 3.87422C12.5468 4.03529 12.6433 4.17629 12.7811 4.26659C12.9188 4.35689 13.0866 4.38919 13.248 4.35645C13.4094 4.32372 13.5514 4.22861 13.643 4.09179C13.7347 3.95497 13.7686 3.7875 13.7375 3.62578C13.3844 1.88672 11.8125 0.625 10 0.625C9.00576 0.626034 8.05253 1.02145 7.34949 1.72449C6.64645 2.42753 6.25103 3.38076 6.25 4.375V6.25H3.75C3.41848 6.25 3.10054 6.3817 2.86612 6.61612C2.6317 6.85054 2.5 7.16848 2.5 7.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V7.5C17.5 7.16848 17.3683 6.85054 17.1339 6.61612C16.8995 6.3817 16.5815 6.25 16.25 6.25ZM16.25 16.25H3.75V7.5H16.25V16.25ZM10.9375 11.875C10.9375 12.0604 10.8825 12.2417 10.7795 12.3958C10.6765 12.55 10.5301 12.6702 10.3588 12.7411C10.1875 12.8121 9.99896 12.8307 9.8171 12.7945C9.63525 12.7583 9.4682 12.669 9.33709 12.5379C9.20598 12.4068 9.11669 12.2398 9.08051 12.0579C9.04434 11.876 9.06291 11.6875 9.13386 11.5162C9.20482 11.3449 9.32498 11.1985 9.47915 11.0955C9.63332 10.9925 9.81458 10.9375 10 10.9375C10.2486 10.9375 10.4871 11.0363 10.6629 11.2121C10.8387 11.3879 10.9375 11.6264 10.9375 11.875Z"
                                          fill="#DAD9D9"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </button>
                              )}

                              {option === NONE && (
                                <div
                                  className="lock-style"
                                  style={{ opacity: "0.5" }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M16.25 6.25H13.75V4.375C13.75 3.38044 13.3549 2.42661 12.6517 1.72335C11.9484 1.02009 10.9946 0.625 10 0.625C9.00544 0.625 8.05161 1.02009 7.34835 1.72335C6.64509 2.42661 6.25 3.38044 6.25 4.375V6.25H3.75C3.41848 6.25 3.10054 6.3817 2.86612 6.61612C2.6317 6.85054 2.5 7.16848 2.5 7.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V7.5C17.5 7.16848 17.3683 6.85054 17.1339 6.61612C16.8995 6.3817 16.5815 6.25 16.25 6.25ZM7.5 4.375C7.5 3.71196 7.76339 3.07607 8.23223 2.60723C8.70107 2.13839 9.33696 1.875 10 1.875C10.663 1.875 11.2989 2.13839 11.7678 2.60723C12.2366 3.07607 12.5 3.71196 12.5 4.375V6.25H7.5V4.375ZM16.25 16.25H3.75V7.5H16.25V16.25ZM10.9375 11.875C10.9375 12.0604 10.8825 12.2417 10.7795 12.3958C10.6765 12.55 10.5301 12.6702 10.3588 12.7411C10.1875 12.8121 9.99896 12.8307 9.8171 12.7945C9.63525 12.7583 9.4682 12.669 9.33709 12.5379C9.20598 12.4068 9.11669 12.2398 9.08051 12.0579C9.04434 11.876 9.06291 11.6875 9.13386 11.5162C9.20482 11.3449 9.32498 11.1985 9.47915 11.0955C9.63332 10.9925 9.81458 10.9375 10 10.9375C10.2486 10.9375 10.4871 11.0363 10.6629 11.2121C10.8387 11.3879 10.9375 11.6264 10.9375 11.875Z"
                                      fill="#DAD9D9"
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {currentStep === 7 && (
              <>
                <div className="mainselect review-box">
                  <div className="selectleft">
                    <h6 className="selecthead">{t("Review & Confirm")}</h6>
                    <p className="selectpara">
                      {t(
                        "Verify all details below. Once confirmed, the Question, Rules, and Outcomes cannot be changed. This action will initiate the transaction."
                      )}
                    </p>
                  </div>
                  <div className="selectrightt">
                    <h4 className="pollhead" style={{ fontSize: "18px", marginBottom: "16px" }}>{question}</h4>
                    <div className="tagmain">
                      {selectedToken === TOKEN_RAIN && <span className="taginner">
                        {'Altcoin'}
                      </span>}
                      {tags.length > 0 ? (
                        tags.map((tag, index) => (
                          <span className="taginner" key={index}>
                            {tag}
                          </span>
                        ))
                      ) : (
                        <span className="taginner">{t("No tags added")}</span>
                      )}
                    </div>
                    <div className="multi-box">
                      <div className="single-box">
                        <p>Start Time</p>
                        <h6>{selectedStartDate
                          ? formatDateTime(selectedStartDate)
                          : t("Not selected")}</h6>
                      </div>
                      <div className="single-box">
                        <p>End Time</p>
                        <h6>{selectedEndDate
                          ? formatDateTime(selectedEndDate)
                          : t("Not selected")}</h6>
                      </div>
                      <div className="single-box">
                        <p>Initial Liquidity</p>
                        <h6 className="green-text">{getTokenSymbol(tokenSymbol)}{formatNumberWithCommas(+inputAmount) || "0.00"}</h6>
                      </div>
                    </div>
                    <div className="market-outcomes">
                      <h6 className="market-head">Market Outcomes {`(${options?.length})`}</h6>
                      {visibleOptions.map((option, index) => (
                        <div className="single-option" key={index}>
                          <div className="left-side">
                            <span
                              className="circle-dot"
                              style={{
                                background: getBackgroundColor(
                                  index,
                                  theme,
                                  options?.length
                                ),
                              }}
                            ></span>

                            <div className="text">
                              <h6>{option}</h6>

                              <ProgressBar className="custom-progress">
                                <ProgressBar
                                  now={barValues[index]}
                                  style={{
                                    backgroundColor: getBackgroundColor(
                                      index,
                                      theme,
                                      options?.length
                                    ),
                                  }}
                                />
                              </ProgressBar>
                            </div>
                          </div>

                          <h5>{Math.round(barValues[index] ?? 0)}%</h5>
                        </div>
                      ))}

                      {options.length > 3 && (
                        <a
                          className="btn-see-more"
                          onClick={() => setShowAll(!showAll)}
                          style={{ cursor: "pointer" }}
                        >
                          {showAll
                            ? "See Less"
                            : `See ${options.length - 3} More`}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            style={{
                              transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "0.3s",
                            }}
                          >
                            <path
                              d="M3.5 5.25L7 8.75L10.5 5.25"
                              stroke="#797979"
                              strokeWidth="1.33333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      )}
                    </div>
                    <div className="resolution-method">
                      <div className="upper-area">
                        <p>Resolution Method</p>
                        <h6>{isPublicPoolResolverAi && !isPrivatePool ? (<><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <path d="M10.2562 4.91035C10.2699 4.89721 10.2833 4.88382 10.2967 4.87019L13.6999 1.38861L15.4829 3.21263L12.0797 6.69421C10.3619 8.45153 7.57676 8.45153 5.85896 6.69421L2.45568 3.21263L4.23868 1.38861L7.64196 4.87019C7.67212 4.90104 7.70305 4.93063 7.73469 4.95895V0H10.2562V4.91035Z" fill="#2C83F6" />
                          <path d="M6.00514 12.4395C5.99699 12.4817 5.98741 12.5239 5.97637 12.566L4.73068 17.3219L7.1663 17.9896L8.41199 13.2337C9.04075 10.8331 7.6482 8.36563 5.30164 7.72241L0.652669 6.44806L4.57764e-05 8.93972L4.64901 10.2141C4.66722 10.2191 4.68529 10.2243 4.70322 10.2298L0.546396 12.685L1.80717 14.9189L6.00514 12.4395Z" fill="#2C83F6" />
                          <path d="M13.2296 10.2623C13.2694 10.2484 13.3099 10.2358 13.3511 10.2245L18 8.95015L17.3474 6.45849L12.6985 7.73284C10.3519 8.37606 8.95934 10.8435 9.5881 13.2441L10.8338 18L13.2694 17.3324L12.0237 12.5764C12.0188 12.5578 12.0143 12.5392 12.0099 12.5205L16.1668 14.9757L17.4275 12.7417L13.2296 10.2623Z" fill="#2C83F6" />
                        </svg> Olympus AI </>) : "Manual"}</h6>
                      </div>
                      <div className="bottom-area">
                        <p>Resolution Rules</p>
                        <p className="body-para">{description}</p>
                      </div>
                    </div>
                    <div className="estimation-box">
                      <div className="single">
                        <p>{t(`Estimated ${NETWORK_FEES}`)}</p>
                        <h6>{t(
                          `$${gasFeeInUsdt?.toFixed(
                            4
                          )}`
                        )}</h6>
                      </div>
                      <div className="single">
                        <p>Oracle Fixed Fee</p>
                        <h6>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(oracleFixedFee)}</h6>
                      </div>
                      <div className="single">
                        <p>Total Liquidity</p>
                        <h6>{getTokenSymbol(tokenSymbol)}{+totalLiquidity?.toFixed(4)}</h6>
                      </div>
                      <div className="single">
                        <p style={{ color: "var(--text-color1)", fontFamily: "hbold" }}>Total Deduction</p>
                        <h6 style={{ color: "#22AC00" }}>{selectedToken === TOKEN_RAIN ? (
                          <>
                            {getTokenSymbol(TOKEN_RAIN)}{formatNumbers(+rainDeduction)} + ${formatNumbers(+usdtDeduction)}
                          </>
                        ) : (
                          <>
                            {getTokenSymbol(tokenSymbol)}{formatNumbers(+totalDeduction)}
                          </>
                        )}</h6>
                      </div>
                    </div>


                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {currentStep === 1 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  onClick={() => handleNextStep(2, true)}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  {t("Back")}
                </button>
                <button
                  onClick={() => handleNextStep(3, true)}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  {t("Back")}
                </button>
                <button
                  onClick={() => handleNextStep(4, true)}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}
        {currentStep === 4 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  {t("Back")}
                </button>
                <button
                  onClick={() => handleNextStep(!isPrivatePool ? 5 : 6, true)}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}
        {currentStep === 5 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  {t("Back")}
                </button>
                <button
                  onClick={() => handleNextStep(6, true)}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}
        {currentStep === 6 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(currentStep - 1)}
                >
                  {t("Back")}
                </button>
                <button
                  disabled={gasFeesSpinner}
                  onClick={() => {
                    if (isSolvencyLimitReached) {
                      setShowSolvencyModal(true);
                      return;
                    }
                    if (!gasFeeInUsdt || gasFeeInUsdt === 0) {
                      notifyError(DEFAULT_ERROR_HEADING, `Error in estimating ${NETWORK_FEES} with this amount. Please try again.`);
                      return;
                    }
                    handleNextStep(7, true);
                  }}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}
        {currentStep === 7 && (
          <div className="bottom-btns">
            <div className="custom-container">
              <div className="innerbtns">
                <button
                  className="back-btn"
                  onClick={() => setCurrentStep(!isPrivatePool ? currentStep - 1 : currentStep - 2)}
                >
                  {t("Back")}
                </button>
                <button
                  disabled={isButtonDisabled}
                  onClick={() => getCreatePrivatePool()}
                  className="continuebtn"
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
      <Modal show={show} onHide={handleClose} centered className="pollmodal createdmarket-modal">
        <Modal.Body>
          {theme === "dark" ? (
            <img
              src="\assets\market\marketcreated-imgdarkv2.svg"
              alt="img"
              className="img-fluid tickimg"
            />
          ) : (
            <img
              src="\assets\market\marketcreated-img.svg"
              alt="img"
              className="img-fluid tickimg"
            />
          )}
          <h6 className="modalhead">{isPrivatePool ? "Private" : "Public"} Market Created</h6>
          {isPrivatePool ?
            <p className="para">Your market has been created and will go live at the start time you specified. <br /> Use the buttons below to share the market link and access code with others.</p> :
            <p className="para">Your market has been created and will go live at the start time you specified. <br /> Use the buttons below to share the market link with others.</p>}
          <div className="questions-parent">
            {
              theme === "light" && (
                <img src="\assets\question-bg.png" alt="img" className="img-fluid questionbg" />
              )
            }
            <div className="top-head">
              <h6 className="dflex-rainimg"> Volume <span>{getTokenSymbol(tokenSymbol)}{formatNumbers(+totalLiquidity)}</span></h6>
              {
                theme === DARK_THEME ? <img src="\assets\riskmarket\darkrain.svg" alt="img" className="img-fluid" /> :
                  <img src="\assets\riskmarket\lightrain.svg" alt="img" className="img-fluid" />
              }
            </div>
            <h4>
              {question}
            </h4>
            <div className="options-parent">
              {options.map((option, index) => (
                <div className="single-option" key={index}>
                  <div className="left-option">
                    <span className="circle-dot" style={{
                      background: getBackgroundColor(
                        index,
                        theme,
                        options?.length
                      ),
                    }}></span>
                    <p className="light-weight">{option}</p>
                  </div>
                  <p className="light-weight">{Math.round(barValues[index] ?? 0)}%</p>
                </div>
              ))}
            </div>
          </div>
          <div className="parent-poll">
            {/* <div className="pollmain">
              <div className="pollleft">
                <p className="idpara">{t("Market ID")}</p>
                <h6 className="idnumber">
                  {poolId?.slice(0, 5)}...{poolId?.slice(-3)}
                </h6>
              </div>
              <div onClick={handleCopyClickId}>
                {isCopiedId ? (
                  <svg
                    className="copysvg"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M13 3L4.75 11L1 7.36364"
                      stroke="#E6FF00"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                      fill={copiedButtonColor}
                    />
                  </svg>
                )}
              </div>
            </div>
            <div className="pollmain">
              <div className="pollleft">
                <p className="idpara">{t("Market Link")}</p>
                <h6 className="idnumber">{truncateUrl(`${SHARE_MARKET}/?id=${poolId}`, 25, 15)}</h6>
              </div>
              <div onClick={handleCopyClickLink}>
                {isCopiedLink ? (
                  <svg
                    className="copysvg"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M13 3L4.75 11L1 7.36364"
                      stroke="#E6FF00"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                      fill={copiedButtonColor}
                    />
                  </svg>
                )}
              </div>
            </div> */}
            {isPrivatePool && (
              <div className="pollmain ">
                <div className="pollleft ">
                  <p className="idpara">{t("Access Code")}</p>
                  <h6 className="idnumber">{createdpool?.accessCode} </h6>
                </div>
                <div onClick={handleCopyClickCode}>
                  {isCopiedCode ? (
                    <svg
                      className="copysvg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M13 3L4.75 11L1 7.36364"
                        stroke="#E6FF00"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                        fill={copiedButtonColor}
                      />
                    </svg>
                  )}
                </div>
              </div>
            )}
            <div className="pollmain">
              <div className="pollleft ">
                <p className="idpara m-0">{t("Share with Friends")}</p>
              </div>
              <div className="socialicons">
                <div
                  onClick={() => optionToVolumnData(SOCIAL_PLATFORMS.TWITTER, twitter_url)}
                  className="socialinner"
                  style={loadingSocialPreview === SOCIAL_PLATFORMS.TWITTER ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                  <img src="\assets\market\twitter.svg" alt="img" className="img-fluid" />
                </div>
                <div
                  onClick={() => optionToVolumnData(SOCIAL_PLATFORMS.FACEBOOK, facebook_url)}
                  className="socialinner"
                  style={loadingSocialPreview === SOCIAL_PLATFORMS.FACEBOOK ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                  <img src="\assets\market\fb.svg" alt="img" className="img-fluid" />
                </div>
                <div
                  onClick={() => optionToVolumnData(SOCIAL_PLATFORMS.TELEGRAM, telegram_url)}
                  className="socialinner"
                  style={loadingSocialPreview === SOCIAL_PLATFORMS.TELEGRAM ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                  <img src="\assets\market\telegram.svg" alt="img" className="img-fluid" />
                </div>
                <div
                  onClick={() => optionToVolumnData(SOCIAL_PLATFORMS.WHATSAPP, whatsapp_url)}
                  className="socialinner"
                  style={loadingSocialPreview === SOCIAL_PLATFORMS.WHATSAPP ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                  <img src="\assets\market\whatsapp.svg" alt="img" className="img-fluid" />
                </div>
                <div
                  onClick={() => optionToVolumnData(SOCIAL_PLATFORMS.EMAIL)}
                  className="socialinner"
                  style={loadingSocialPreview === SOCIAL_PLATFORMS.EMAIL ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                >
                  <img src="\assets\market\email.svg" alt="img" className="img-fluid" />
                </div>

                <div onClick={copyPoolLink} className="socialinner">
                  <img src="\assets\market\link.svg" alt="img" className="img-fluid" />
                  {/* {isCopied ? (
                <p className="socialpara">{t("Copied")}</p>
              ) : (
                <p className="socialpara">{t("Copy Link")}</p>
              )} */}
                </div>
              </div>
            </div>
          </div>
          <button onClick={handleClose} className="okaybtn">
            {t("Done")}
          </button>
        </Modal.Body>
      </Modal>
      <Modal
        className="round transaction-modal"
        show={show7}
        onHide={handleClose7}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body style={{ padding: "28px 22px" }}>
          <div className="maincontent">
            <h4 className="mt-0">{message}</h4>
            <p className="paraplacing">
              {t(
                `Transaction in progress!`
              )}
              <br />
              {t(
                `Blockchain validation is underway. This may take a few moments.`
              )}
            </p>
            <ProgressiveProgressBar active={startProgressBar} />
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="liquidity openadispute-modal"
        show={!!pendingNavPath}
        onHide={handleCloseLeaving}
        centered
      >
        <Modal.Body>
          <div className="innercontent p-0">
            <div className="upperimg">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="35" viewBox="0 0 32 35" fill="none">
                <g filter="url(#filter0_d_7262_10555)">
                  <path d="M18.5 25C18.5 25.4945 18.3534 25.9778 18.0787 26.3889C17.804 26.8001 17.4135 27.1205 16.9567 27.3097C16.4999 27.4989 15.9972 27.5484 15.5123 27.452C15.0273 27.3555 14.5819 27.1174 14.2322 26.7678C13.8826 26.4181 13.6445 25.9727 13.548 25.4877C13.4516 25.0028 13.5011 24.5001 13.6903 24.0433C13.8795 23.5865 14.2 23.196 14.6111 22.9213C15.0222 22.6466 15.5055 22.5 16 22.5C16.663 22.5 17.2989 22.7634 17.7678 23.2322C18.2366 23.7011 18.5 24.337 18.5 25ZM16 20C16.3978 20 16.7794 19.842 17.0607 19.5607C17.342 19.2794 17.5 18.8978 17.5 18.5V6C17.5 5.60218 17.342 5.22064 17.0607 4.93934C16.7794 4.65804 16.3978 4.5 16 4.5C15.6022 4.5 15.2206 4.65804 14.9393 4.93934C14.658 5.22064 14.5 5.60218 14.5 6V18.5C14.5 18.8978 14.658 19.2794 14.9393 19.5607C15.2206 19.842 15.6022 20 16 20Z" fill="#212121" />
                </g>
                <defs>
                  <filter id="filter0_d_7262_10555" x="-3.65714" y="0" width="39.3143" height="39.3143" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="3.65714" />
                    <feGaussianBlur stdDeviation="1.82857" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7262_10555" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7262_10555" result="shape" />
                  </filter>
                </defs>
              </svg>
            </div>
            <h2 className="upperheading">{t("Cancel Market Creation")}</h2>
            <p className="para">
              {t("If you leave now, you will lose all progress and will need to start over from the beginning.")}
            </p>
          </div>
          <div className="twice-btns">
            <a onClick={() => handleLeaveNavigation()} className="btn-cancel">
              {t("Cancel & Exit")}
            </a>
            <a onClick={() => handleCloseLeaving()} className="btn-save">
              {t("Continue Setup")}
            </a>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="liquidity openadispute-modal"
        show={false}
        // onHide={handleCloseLeaving}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Connect Wallet
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="innercontent p-0">
            <h2 className="upperheading">{t("Wallet Connection Required")}</h2>
            <p className="para">
              {t("Please connect your wallet in order to continue.")}
            </p>
          </div>
          <div className="twice-btns">
            <a className="btn-cancel">
              {t("Back")}
            </a>
            <a className="btn-save">
              {t("Connect Wallet")}
            </a>
          </div>
        </Modal.Body>
      </Modal>
      <SolvencyLimitModal show={showSolvencyModal} onHide={() => setShowSolvencyModal(false)} />
    </>
  );
};

export default Createpool;
